// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:32:35.317Z
// Property: Summit Ridge Villas (ID: 6767906449167297)
// Collections: 11 amenities, 1 floorplans (live), 16 photos, 87 POIs, 1 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167297",
  "property_external_id": "2009547",
  "property_zillow_url": "https://www.zillow.com/apartments/oklahoma-city-ok/summit-villas/CnRYVX/",
  "property_apartments_url": "https://www.apartments.com/summit-ridge-villas-oklahoma-city-ok/twh21zc/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "summit-ridge-villas",
  "property_name": "Summit Ridge Villas",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/summit-ridge-villas/",
  "property_domain": null,
  "property_address": "1721 NW 115th Terrace",
  "property_full_address": "1721 NW 115th Terrace, Oklahoma City, OK, 73120",
  "property_address_1": "1721 NW 115th Terrace",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73120",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Northwest Oklahoma City",
  "property_address_latitude": "35.5869",
  "property_address_longitude": "-97.5444",
  "property_email": "summitridge@caseusa.com",
  "property_phone": "4057846734",
  "property_call_tracking_phone": "866-883-9106",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Summit Ridge Villas in Oklahoma City, where modern living meets comfort. Choose from our spacious two-bedroom floor plans and indulge in thoughtful amenities like pet-friendly spaces, outdoor retreats, and energy-efficient appliances. Experience the ideal blend of style and convenience—your new home awaits just a click away! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Summit Ridge Villas, your perfect oasis in Oklahoma City, OK! Our thoughtfully designed two-bedroom apartments offer an ideal blend of comfort and convenience, tailored for your modern lifestyle. Discover spacious floor plans featuring energy-efficient stainless steel appliances, walk-in closets, and an inviting eat-in kitchen that’s perfect for entertaining. Enjoy the luxury of outdoor living with private balconies, patios, and fenced yards that create your own personal retreat.\n\nAt Summit Ridge Villas, we prioritize your needs with a range of exceptional amenities. Bring your furry friends along to explore our pet play area, while you enjoy the ease of online services for rental payments and maintenance requests. Our community is equipped with preinstalled Wi-Fi powered by Cox, ensuring that you're always connected, whether you're working from home or streaming your favorite shows.\n\nStay comfortable year-round with air conditioning and heating, complemented by ceiling fans to enhance your living experience. Enjoy hassle-free laundry days with washer/dryer hookups in each apartment. With vinyl flooring and window coverings, your new home is as stylish as it is practical.\n\nExperience the warmth and convenience of Summit Ridge Villas – where every detail is designed with you in mind. Don’t wait to find your new home; browse our availability or schedule a tour today to explore our vibrant community and see for yourself why Summit Ridge Villas is the perfect place for you to call home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-b841-7774-acca-099d805875f4.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of townhomes with attached garages and a monument sign.",
    "public_id": "019cfb55-b841-7774-acca-099d805875f4",
    "storage_key": "property/6767906449167297/019cfb55-b841-7774-acca-099d805875f4.webp",
    "width": 1536,
    "height": 1025
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "94",
  "property_year_built": "2025",
  "property_year_renovated": null,
  "property_walk_score": "2",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "80",
  "property_pet_restrictions": "Maximum 2 pets per unit. Maximum weight: 80 lb each.",
  "property_pet_policy_description": "Dogs and cats allowed. One-time pet fee: $500. Monthly pet rent: $30. Maximum 2 pets per unit. Maximum weight: 80 lb each.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://summitvillasokc.securecafe.com/onlineleasing/summit-ridge-villas/floorplans.aspx",
  "property_resident_portal_url": "https://summitvillasokc.securecafenet.com/residentservices/summit-ridge-villas/userlogin",
  "property_apply_now_url": "https://summitvillasokc.securecafe.com/onlineleasing/summit-ridge-villas/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-ec18-75dc-bf4d-a19cea16f913.webp",
  "property_primary_logo_media": {
    "alt_text": "Chisholm Pointe and Summit Villas logos",
    "public_id": "019cfb55-ec18-75dc-bf4d-a19cea16f913",
    "storage_key": "property/6767906449167297/019cfb55-ec18-75dc-bf4d-a19cea16f913.webp",
    "width": 640,
    "height": 201
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-f8d0-7249-bbc8-69cfd9d8a07d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Chisholm Pointe and Summit Villas logos",
    "public_id": "019cfb55-f8d0-7249-bbc8-69cfd9d8a07d",
    "storage_key": "property/6767906449167297/019cfb55-f8d0-7249-bbc8-69cfd9d8a07d.webp",
    "width": 640,
    "height": 201
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb89-46e9-748e-9ddc-9f2ae9f4af04.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Chisholm Pointe and Summit Villas logo",
    "public_id": "019cfb89-46e9-748e-9ddc-9f2ae9f4af04",
    "storage_key": "property/6767906449167297/019cfb89-46e9-748e-9ddc-9f2ae9f4af04.webp",
    "width": 640,
    "height": 201
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#000000",
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "933 - 933",
  "property_sqft_min": "933",
  "property_sqft_max": "933",
  "property_price_range": "1475 - 1475",
  "property_price_min": "1475",
  "property_price_max": "1475",
  "property_available_units": 2,
  "property_facebook_url": "https://www.facebook.com/CaseAndAssociates",
  "property_instagram_url": "https://www.instagram.com/villateresaresidences/?hl=en",
  "property_twitter_url": "https://x.com/caseassociateok",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJB-MkaQAZsocREX1DzpcUptM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/chisholm-pointe-oklahoma-city",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Summit Ridge Villas",
  "property_home_romance_title": "Embrace Life and Love at Your New Apartment Community",
  "property_home_amenities_blurb": "At Summit Ridge Villas in Oklahoma City, enjoy luxurious two-bedroom floor plans designed for modern living. Indulge in a pet-friendly environment with outdoor living spaces, energy-efficient stainless appliances, and walk-in closets. Experience effortless online services, including rental payments and preinstalled Wi-Fi, all in a vibrant community that feels like home.",
  "property_home_floorplans_blurb": "Welcome to Summit Ridge Villas, where your ideal living space awaits in the heart of Oklahoma City. Our thoughtfully designed floor plans cater to every lifestyle, blending comfort with modern elegance. Dive into our selection of available apartment homes and uncover the perfect fit for your unique lifestyle.",
  "property_home_gallery_blurb": "At Summit Ridge Villas in Oklahoma City, your ideal two-bedroom home awaits. Enjoy the perfect blend of comfort and convenience with spacious outdoor areas, pet-friendly amenities, and stylish interiors featuring energy-efficient stainless steel appliances. Picture yourself relaxing on your private balcony or unwinding in our secure, fenced yards.",
  "property_home_neighborhood_blurb": "Welcome to Summit Ridge Villas, where vibrant living meets endless adventure in Oklahoma City. Nestled near the Oklahoma City Zoo and the National Cowboy & Western Heritage Museum, our two-bedroom floor plans offer a gateway to local culture and nature. Experience a community rich in parks, museums, and leisure activities!",
  "property_home_reviews_blurb": "Nestled in the heart of Oklahoma City, Summit Ridge Villas is where comfort meets community. Our residents rave, “Living here feels like home!” With top-notch amenities and a welcoming atmosphere, it's no wonder so many choose to call us home. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Summit Ridge Villas, vibrant living meets rich culture. Nestled in the heart of Oklahoma City, you'll find the captivating Oklahoma City Zoo, the immersive Science Museum Oklahoma, and nature's embrace at Martin Park. With easy access to the National Cowboy & Western Heritage Museum, your adventure awaits just outside your door! ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Summit Ridge Villas in Oklahoma City, enjoy life's finer comforts with spacious two-bedroom floor plans and a wealth of amenities. Unwind in outdoor living areas, let your pets roam in the play area, and savor energy-efficient stainless steel appliances—all designed for your ultimate relaxation and convenience.",
  "property_applynow_blurb": "At Summit Ridge Villas in Oklahoma City, comfort meets modern living. Choose from spacious two-bedroom floor plans equipped with energy-efficient stainless steel appliances and preinstalled Wi-Fi. Enjoy fenced yards, outdoor living areas, and a pet play space, all while making online rental payments with ease. Lease online today to find your perfect home!",
  "property_contactus_blurb": "At Summit Ridge Villas in Oklahoma City, our spacious two-bedroom floor plans are designed for comfort and modern living. With stunning views and thoughtful layouts, you'll find the perfect space to call home. Have questions? Our leasing team is ready to help you every step of the way!",
  "property_faqs_blurb": "At Summit Ridge Villas in Oklahoma City, our spacious two-bedroom floor plans are designed for comfort and style. Have questions? Uncover the details you need by visiting our FAQs page, where you’ll find answers tailored to enhance your living experience in our vibrant community.",
  "property_floorplans_blurb": "At Summit Ridge Villas in Oklahoma City, experience the perfect blend of comfort and style with our spacious two-bedroom floor plans. Each layout is designed to elevate your living experience. Browse our available apartment homes today and uncover the ideal space that suits your lifestyle.",
  "property_gallery_blurb": "At Summit Ridge Villas in Oklahoma City, our spacious two-bedroom apartments blend modern comfort with stylish design. Picture relaxing in outdoor living areas or enjoying your pet in our dedicated play zone. With energy-efficient appliances and convenient online services, your ideal home awaits—imagine the possibilities!",
  "property_interactivemap_blurb": "Welcome to Summit Ridge Villas in Oklahoma City, where modern living meets convenience. Our spacious two-bedroom apartments feature energy-efficient stainless steel appliances, private balconies, and fenced yards. Enjoy our pet play area, outdoor living spaces, and hassle-free online rental services. Use our interactive map to find your perfect home today!",
  "property_pets_blurb": "At Summit Ridge Villas in Oklahoma City, your pets are not just allowed—they're celebrated! With spacious living tailored for both you and your furry friends, enjoy the breathtaking views and vibrant community. Bring up to two pets, each weighing up to 80 lbs, and let the adventures begin! ",
  "property_referafriend_blurb": "At Summit Ridge Villas in Oklahoma City, our spacious two-bedroom floor plans are designed for modern living. Share the joy of community by referring a friend today—great friends make great neighbors! Together, you can enjoy all the comforts and amenities our vibrant apartment community has to offer.",
  "property_residentaccess_blurb": "Welcome to Summit Ridge Villas in vibrant Oklahoma City, where comfort meets convenience! Our spacious two-bedroom floor plans are designed for modern living. Log in to your resident portal for seamless rent payments, hassle-free maintenance requests, and quick access to community updates. Elevate your living experience today!",
  "property_reviews_blurb": "At Summit Ridge Villas in Oklahoma City, our residents love calling this community home! One happy tenant raves, “The sense of community and stunning views make it an exceptional place to live.” See what our residents have to say about living at our welcoming apartment community!",
  "property_created_at": "1772733220435",
  "property_scheduletour_blurb": "At Summit Ridge Villas in Oklahoma City, our spacious two-bedroom floor plans blend comfort with style. Experience a vibrant community nestled in scenic surroundings. Ready to envision your new home? Schedule a tour today and see what our residents love most about life at Summit Ridge Villas!",
  "property_thankyou_blurb": "Thank you for your interest in Summit Ridge Villas! Nestled in vibrant Oklahoma City, our spacious two-bedroom floor plans offer a harmonious blend of comfort and style. A team member will reach out soon to help you envision your new home amidst the stunning views and community perks.",
  "property_virtualtours_blurb": "Embrace your new lifestyle at Summit Ridge Villas in Oklahoma City, where our spacious two-bedroom floor plans cater to comfort and style. Experience every detail from the comfort of your home—take a virtual tour of our inviting community and envision the perfect space for your next chapter!",
  "property_copyright": "2026 All Rights Reserved. Summit Ridge Villas",
  "property_seo_title_home": "Summit Ridge Villas |  Apartments in Oklahoma City, OK",
  "property_seo_description_home": "Discover modern living at Summit Ridge Villas in OKC! Enjoy spacious two-bedroom homes, pet-friendly amenities, and outdoor retreats. Find your home today!",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Summit Ridge Villas in Oklahoma City! Browse our diverse two-bedroom floor plans and envision your new home today.",
  "property_seo_title_amenities": "Amenities | Oklahoma City, OK Apartments for Rent",
  "property_seo_description_amenities": "Enjoy modern living at Summit Ridge Villas in Oklahoma City! With spacious two-bedroom layouts and exceptional amenities, your dream home awaits.",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, OK",
  "property_seo_description_gallery": "Experience life at Summit Ridge Villas: spacious two-bedroom layouts, modern amenities, and a vibrant community. Your ideal home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Summit Ridge Villas Apartments",
  "property_seo_description_virtualtours": "Experience Summit Ridge Villas in Oklahoma City! Take a virtual tour of our stunning two-bedroom apartments and find your perfect home today.",
  "property_seo_title_interactivemap": "Interactive Map | Summit Ridge Villas Apartments",
  "property_seo_description_interactivemap": "Discover your oasis at Summit Ridge Villas, OKC! Spacious two-bedroom layouts, pet-friendly options, and vibrant outdoor living await. Explore now!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, OK",
  "property_seo_description_neighborhood": "Uncover the vibrant life at Summit Ridge Villas in OKC! Get to know your new neighborhood, local favorites, and nearby attractions in every direction.",
  "property_seo_title_contact": "Contact Us | Summit Ridge Villas",
  "property_seo_description_contact": "Elevate your lifestyle at Summit Ridge Villas in Oklahoma City! Need info on our two-bedroom floor plans? Reach out to our friendly leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, OK",
  "property_seo_description_faqs": "Find answers to your questions about life at Summit Ridge Villas in Oklahoma City. Check out our FAQs for community insights and pet-friendly amenities!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, OK",
  "property_seo_description_reviews": "Discover life at Summit Ridge Villas in OKC! Enjoy pet-friendly amenities, spacious layouts, and vibrant outdoor areas. Hear our residents' stories!",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, OK",
  "property_seo_description_applynow": "Elevate your lifestyle at Summit Ridge Villas, OKC! Enjoy spacious two-bedroom layouts, energy-efficient amenities, and outdoor living. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Summit Ridge Villas",
  "property_seo_description_residentaccess": "Unlock convenience at Summit Ridge Villas! Log in to your resident portal for easy rent payment, maintenance requests, and community updates in Oklahoma City.",
  "property_seo_title_referafriend": "Refer A Friend | Summit Ridge Villas",
  "property_seo_description_referafriend": "Elevate your lifestyle at Summit Ridge Villas! Refer a friend today and enjoy great company in our vibrant Oklahoma City community. Unmatched living awaits!",
  "property_seo_title_scheduletour": "Schedule a Tour | Summit Ridge Villas",
  "property_seo_description_scheduletour": "Experience upscale living at Summit Ridge Villas in Oklahoma City! Schedule your tour today and embrace modern amenities and vibrant community vibes.",
  "property_seo_title_privacy": "Privacy Policy | Summit Ridge Villas",
  "property_seo_description_privacy": "Your privacy matters at Summit Ridge Villas. Dive into our policy for transparent information on how we protect your data in Oklahoma City. View now!",
  "property_seo_title_accessibility": "Website Accessibility | Summit Ridge Villas",
  "property_seo_description_accessibility": "At Summit Ridge Villas, we promote digital inclusion for all. Check our Accessibility Statement to see how we support everyone’s needs!",
  "property_seo_title_sitemap": "Sitemap | Summit Ridge Villas",
  "property_seo_description_sitemap": "Uncover the living experience at Summit Ridge Villas in Oklahoma City, OK. Navigate our sitemap to find the perfect home tailored for your lifestyle.",
  "property_seo_title_thankyou": "Thank You | Summit Ridge Villas",
  "property_seo_description_thankyou": "Thank you for reaching out to Summit Ridge Villas! Our team will connect with you soon to help you find your perfect Oklahoma City home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865821111",
  "amenities": [
    {
      "id": "ec_fbb965f5ee3052d51a0af988",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "yardi",
      "external_id": "127397180",
      "title": "On-Site Management at Chisholm Pointe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b254df042efc885b2cc12b67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "yardi",
      "external_id": "127397181",
      "title": "On-Site Maintenance at Chisholm Pointe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_813ab9151bef9af35a89f6c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "yardi",
      "external_id": "127397183",
      "title": "Clubhouse at Chisholm Pointe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c0dc54853af91f619796569",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "yardi",
      "external_id": "128017321",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38bac327c629b7948b720b94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "yardi",
      "external_id": "127398635",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_329394837a28119af95283ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "yardi",
      "external_id": "127398636",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf867fdbac762a2076585488",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "yardi",
      "external_id": "127398637",
      "title": "Fenced Yards",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32d1a548d631ac0a300ab3f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "yardi",
      "external_id": "127398639",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e3e1176d3bf422910da4272",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "yardi",
      "external_id": "127398640",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_177a170f803253a4930382d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "yardi",
      "external_id": "127398641",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c20851f4920f6447d4eefb38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "yardi",
      "external_id": "127398642",
      "title": "Stackable Full-Size Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_39b6e078-a522-4f1d-bae2-796c33c22fd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bb-abbc-7088-ba96-36addb114ef2.webp",
      "image_media": {
        "alt_text": "White brick community entrance sign reading 'Chisholm Pointe' with trees and sidewalk.",
        "public_id": "019d20bb-abbc-7088-ba96-36addb114ef2",
        "storage_key": "property/6767906449167297/019d20bb-abbc-7088-ba96-36addb114ef2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Entrance sign for the Chisholm Pointe multifamily community, featuring a white brick wall, large branding, and surrounding landscaping.",
      "link": "",
      "alt_text": "White brick community entrance sign reading 'Chisholm Pointe' with trees and sidewalk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2F6c68e04789b2eff6c32e8840f0c92c9d.webp"
    },
    {
      "id": "custom_6b8d1afd-b798-4bc1-80f7-7d14be862f8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bb-aafe-746a-84dd-86637b88f489.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment community building with a curved driveway and landscaped entrance.",
        "public_id": "019d20bb-aafe-746a-84dd-86637b88f489",
        "storage_key": "property/6767906449167297/019d20bb-aafe-746a-84dd-86637b88f489.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of a single-story apartment building with blue-gray siding, stone accents, and manicured landscaping at a curved entry.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment community building with a curved driveway and landscaped entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2F8a31a1f6bfe7184064cad59c20eb74ec.webp"
    },
    {
      "id": "custom_2c577c2a-3f66-4215-b51f-90552b8a73bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bb-df63-779c-8762-e23d045dfaf0.webp",
      "image_media": {
        "alt_text": "Outdoor community grilling area with stainless steel grills and brick countertops on a concrete patio.",
        "public_id": "019d20bb-df63-779c-8762-e23d045dfaf0",
        "storage_key": "property/6767906449167297/019d20bb-df63-779c-8762-e23d045dfaf0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Outdoor community grilling area with stainless steel grills, brick countertops, and a concrete patio.",
      "link": "",
      "alt_text": "Outdoor community grilling area with stainless steel grills and brick countertops on a concrete patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2Fddd9a9d57a5c8434deb7f478da2c6fb0.webp"
    },
    {
      "id": "custom_fd3b2f50-9a66-42f1-a664-ff78a82c25a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bb-e0a5-7730-b3fd-0131d7bee571.webp",
      "image_media": {
        "alt_text": "Outdoor community courtyard with a round table, chairs, umbrella, lounge chairs, and a wooden fence.",
        "public_id": "019d20bb-e0a5-7730-b3fd-0131d7bee571",
        "storage_key": "property/6767906449167297/019d20bb-e0a5-7730-b3fd-0131d7bee571.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Sunlit outdoor community space with seating, loungers, and manicured landscaping.",
      "link": "",
      "alt_text": "Outdoor community courtyard with a round table, chairs, umbrella, lounge chairs, and a wooden fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2F4a4b0a94d7c537dd865f239bc9cb0ce1.webp"
    },
    {
      "id": "custom_768691a4-1ca4-42eb-94c8-d82949f5a717",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bb-cb90-76ba-83df-37949afcec34.webp",
      "image_media": {
        "alt_text": "Outdoor community pool with deck, lounge chairs, and fencing.",
        "public_id": "019d20bb-cb90-76ba-83df-37949afcec34",
        "storage_key": "property/6767906449167297/019d20bb-cb90-76ba-83df-37949afcec34.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Outdoor pool area at a multifamily community with sun loungers and a fenced perimeter.",
      "link": "",
      "alt_text": "Outdoor community pool with deck, lounge chairs, and fencing.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2F7278d9459c8b62651ff6d85c1bb6799e.webp"
    },
    {
      "id": "custom_3e23e419-9bc5-4fca-8655-1b2698a3f4a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bc-01f9-764d-9efc-d9bdd7af70b1.webp",
      "image_media": {
        "alt_text": "Outdoor community pool with a spacious deck, lounge chairs, and a covered seating area.",
        "public_id": "019d20bc-01f9-764d-9efc-d9bdd7af70b1",
        "storage_key": "property/6767906449167297/019d20bc-01f9-764d-9efc-d9bdd7af70b1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Spacious outdoor pool at a multifamily community with lounge chairs and a covered seating area.",
      "link": "",
      "alt_text": "Outdoor community pool with a spacious deck, lounge chairs, and a covered seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2Ffab4e33ea4535d992e1ac5be1002132e.webp"
    },
    {
      "id": "custom_2dc03f7d-74d0-4065-9dfe-f6714cb0ae18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bb-ab07-771c-a8b7-3b51d99a4694.webp",
      "image_media": {
        "alt_text": "Open-concept living area with vaulted white ceiling, exposed wooden beams, large windows, and a fireplace.",
        "public_id": "019d20bb-ab07-771c-a8b7-3b51d99a4694",
        "storage_key": "property/6767906449167297/019d20bb-ab07-771c-a8b7-3b51d99a4694.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Bright, modern apartment living room with a kitchen island, seating, a fireplace, and abundant natural light.",
      "link": "",
      "alt_text": "Open-concept living area with vaulted white ceiling, exposed wooden beams, large windows, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2Fcb74f1f8d6f8d6b34d340c0fb9748d88.webp"
    },
    {
      "id": "custom_81824932-131e-496c-ac91-b972e14a0dc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bb-b4a6-76fe-81e3-65daa98107da.webp",
      "image_media": {
        "alt_text": "Bright living room with vaulted ceiling, exposed wooden beams, fireplace, wall-mounted TV, and large pool-view windows.",
        "public_id": "019d20bb-b4a6-76fe-81e3-65daa98107da",
        "storage_key": "property/6767906449167297/019d20bb-b4a6-76fe-81e3-65daa98107da.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious modern living area with vaulted ceiling, fireplace, wall-mounted TV, and large pool-view windows.",
      "link": "",
      "alt_text": "Bright living room with vaulted ceiling, exposed wooden beams, fireplace, wall-mounted TV, and large pool-view windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2F30276ecee09000bb0a2ce95f91acb727.webp"
    },
    {
      "id": "custom_ff7bd3f4-d33f-4f48-acd2-575c4e5915e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bb-bddf-7215-8abb-9962636c2acf.webp",
      "image_media": {
        "alt_text": "Bright modern kitchen with white cabinets, island, open shelves, and a large window.",
        "public_id": "019d20bb-bddf-7215-8abb-9962636c2acf",
        "storage_key": "property/6767906449167297/019d20bb-bddf-7215-8abb-9962636c2acf.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Sunlit apartment kitchen with a large white island, open wood shelves, and modern stainless appliances.",
      "link": "",
      "alt_text": "Bright modern kitchen with white cabinets, island, open shelves, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2Fb3e99c32f5764c08ebb10a2f10f7ecb8.webp"
    },
    {
      "id": "custom_16d125f7-dc7c-4a06-9430-00338e046246",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bb-f330-7798-877a-bcc8a386a54a.webp",
      "image_media": {
        "alt_text": "Modern gray bathroom with vanity, toilet, and tiled tub surround.",
        "public_id": "019d20bb-f330-7798-877a-bcc8a386a54a",
        "storage_key": "property/6767906449167297/019d20bb-f330-7798-877a-bcc8a386a54a.webp",
        "width": 1157,
        "height": 772
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring gray cabinetry, marble-look tile, a bathtub, and light wood flooring.",
      "link": "",
      "alt_text": "Modern gray bathroom with vanity, toilet, and tiled tub surround.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2Fafcba01829ba040b61b45005c2de98be.webp"
    },
    {
      "id": "custom_e39fb543-fc1c-424b-ac94-4b4d998f4e4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bb-fae1-7721-8309-f77e3028958f.webp",
      "image_media": {
        "alt_text": "Bright bedroom in a modern apartment with a wooden bed, nightstand, and window curtains.",
        "public_id": "019d20bb-fae1-7721-8309-f77e3028958f",
        "storage_key": "property/6767906449167297/019d20bb-fae1-7721-8309-f77e3028958f.webp",
        "width": 936,
        "height": 624
      },
      "title": "Apartment",
      "description": "Cozy, contemporary bedroom in a well-lit apartment featuring a wooden bed frame, nightstand, and soft neutral decor.",
      "link": "",
      "alt_text": "Bright bedroom in a modern apartment with a wooden bed, nightstand, and window curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2Fdbb294f7b36fe6abc5284a36b252ba34.webp"
    },
    {
      "id": "custom_270e692c-14b2-42af-bf07-76a320738a9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bc-04af-713c-a3b6-523da0de3752.webp",
      "image_media": {
        "alt_text": "Bright living room with a peach sofa, round coffee table, plants, and large windows.",
        "public_id": "019d20bc-04af-713c-a3b6-523da0de3752",
        "storage_key": "property/6767906449167297/019d20bc-04af-713c-a3b6-523da0de3752.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Inviting model living room in a modern apartment with natural light, neutral decor, and greenery.",
      "link": "",
      "alt_text": "Bright living room with a peach sofa, round coffee table, plants, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2F62cb5d2cffdcb865ebd518f031d170c0.jpg"
    },
    {
      "id": "custom_00fbbb34-89b7-43c7-ad57-572c30a0a6f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bc-0cd8-7396-b944-77fe1c33f2d0.webp",
      "image_media": {
        "alt_text": "Aerial view of a downtown skyline with tall modern buildings against a blue sky.",
        "public_id": "019d20bc-0cd8-7396-b944-77fe1c33f2d0",
        "storage_key": "property/6767906449167297/019d20bc-0cd8-7396-b944-77fe1c33f2d0.webp",
        "width": 1254,
        "height": 836
      },
      "title": "Lifestyle",
      "description": "Bird's-eye view of a downtown skyline featuring modern skyscrapers and historic brick buildings.",
      "link": "",
      "alt_text": "Aerial view of a downtown skyline with tall modern buildings against a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2F76967eed474d7ffc3bd8a8b9251f43d9.jpg"
    },
    {
      "id": "custom_d5e0ccd8-2fb3-4305-9892-0ef83f6dd3da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bc-155b-7069-9931-7d39f7a3219d.webp",
      "image_media": {
        "alt_text": "City skyline at dusk with illuminated streets and a tall glass skyscraper.",
        "public_id": "019d20bc-155b-7069-9931-7d39f7a3219d",
        "storage_key": "property/6767906449167297/019d20bc-155b-7069-9931-7d39f7a3219d.webp",
        "width": 2000,
        "height": 650
      },
      "title": "Lifestyle",
      "description": "A panoramic view of a metropolitan skyline at dusk with illuminated streets and tall buildings.",
      "link": "",
      "alt_text": "City skyline at dusk with illuminated streets and a tall glass skyscraper.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2Fd51dc6252caa373b128e07b116563cc2.webp"
    },
    {
      "id": "custom_448c8ba5-8219-40dd-a16f-7c7a7a539959",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bc-1de8-73e1-9b36-3f0ccf16f1ff.webp",
      "image_media": {
        "alt_text": "Close-up of hands holding a white travel mug with a black lid beside a bicycle.",
        "public_id": "019d20bc-1de8-73e1-9b36-3f0ccf16f1ff",
        "storage_key": "property/6767906449167297/019d20bc-1de8-73e1-9b36-3f0ccf16f1ff.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "Lifestyle image showing a person with a denim shirt holding a white travel mug near a bicycle.",
      "link": "",
      "alt_text": "Close-up of hands holding a white travel mug with a black lid beside a bicycle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2F301c52f434bc61b47e662744522cd5ea.webp"
    },
    {
      "id": "custom_e83eb216-8190-4163-a2c9-de7cf9ba015b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d20bc-1f05-728e-84c2-c495644612bc.webp",
      "image_media": {
        "alt_text": "Children with backpacks lining up to board a yellow school bus.",
        "public_id": "019d20bc-1f05-728e-84c2-c495644612bc",
        "storage_key": "property/6767906449167297/019d20bc-1f05-728e-84c2-c495644612bc.webp",
        "width": 788,
        "height": 663
      },
      "title": "Lifestyle",
      "description": "Kids with colorful backpacks line up to board a yellow school bus, capturing a cheerful morning scene.",
      "link": "",
      "alt_text": "Children with backpacks lining up to board a yellow school bus.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449167297%2Fb0bee95f570abd714e166175fc587c80.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a66b536b-fd80-4cbc-af3b-f04af644bec2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Topgolf Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "13313 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with multiple games to choose from, and a variety of drinks and appetizers. They also highlight the fun atmosphere, suitable for families and groups, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-c4f6-7499-ae92-27e2c78b0ed8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-c4f6-7499-ae92-27e2c78b0ed8",
        "storage_key": "property/6767906449167297/019d270f-c4f6-7499-ae92-27e2c78b0ed8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17880991546737991946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-oklahoma-city",
      "poi_latitude": "35.6027127",
      "poi_longitude": "-97.5351879",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-607-7154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb5c-77af-ab4c-2d8d8c8bb472.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb5c-77af-ab4c-2d8d8c8bb472",
        "storage_key": "property/6767906449167297/019d270f-fb5c-77af-ab4c-2d8d8c8bb472.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0r8qRocsocRCqEU_xILJvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e802cf22-28c5-4d2d-ab1f-b5e63f09bd12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "8400 N Oklahoma Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Bar with games such as pickleball and bocce and an on-site restaurant menu that encompasses wings to chicken sandwiches.",
      "poi_long_description": "People say this restaurant offers a variety of food, including chicken, ribs, and salads, and has many pickleball courts and other games. They also highlight the fun and chill atmosphere, and the friendly and helpful staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-c438-7752-bcaf-b8532229b9e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-c438-7752-bcaf-b8532229b9e1",
        "storage_key": "property/6767906449167297/019d270f-c438-7752-bcaf-b8532229b9e1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://chickennpickle.com/location/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4621211403201137082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---oklahoma-city",
      "poi_latitude": "35.5567671",
      "poi_longitude": "-97.5089424",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-839-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb5c-77af-ab4c-2d8d8c8bb472.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb5c-77af-ab4c-2d8d8c8bb472",
        "storage_key": "property/6767906449167297/019d270f-fb5c-77af-ab4c-2d8d8c8bb472.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbbROHYZsocRusnJd0nXIUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1e91327f-77f7-4c8a-a87a-a7138a91a0d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "5600 N Pennsylvania Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious cheesecake and offers a wide variety of menu options. They also highlight the large portions, the attentive and friendly service, and the fun, nostalgic atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-c456-72f3-a282-ea7d6ce7816c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-c456-72f3-a282-ea7d6ce7816c",
        "storage_key": "property/6767906449167297/019d270f-c456-72f3-a282-ea7d6ce7816c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/oklahoma-city-117.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=931265600312329473&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "35.5260485",
      "poi_longitude": "-97.5471558",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-843-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb5c-77af-ab4c-2d8d8c8bb472.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb5c-77af-ab4c-2d8d8c8bb472",
        "storage_key": "property/6767906449167297/019d270f-fb5c-77af-ab4c-2d8d8c8bb472.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgc4NZkAasocRAUUoIiGF7Aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_17784dc5-4e0b-43b2-b422-f29ef55dc44c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Cafe Kacao",
      "poi_type": "Restaurants",
      "poi_address": "3325 N Classen Blvd, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Breakfast hot spot featuring a menu full of homestyle Guatemalan favorites & Latin-themed cuisine.",
      "poi_long_description": "People say this Guatemalan restaurant serves delicious pancakes, omelets, and pupusas, and offers a wide selection of unique coffee drinks. They highlight the generous portions, flavorful dishes, and vibrant atmosphere. They also like the friendly, attentive, and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-c4e2-726d-9ea4-8c63f8a27a0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-c4e2-726d-9ea4-8c63f8a27a0f",
        "storage_key": "property/6767906449167297/019d270f-c4e2-726d-9ea4-8c63f8a27a0f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cafekacao.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4497070532078455595&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cafe-kacao",
      "poi_latitude": "35.5038943",
      "poi_longitude": "-97.5347616",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-357-9913",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb5c-77af-ab4c-2d8d8c8bb472.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb5c-77af-ab4c-2d8d8c8bb472",
        "storage_key": "property/6767906449167297/019d270f-fb5c-77af-ab4c-2d8d8c8bb472.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1xxbagQsocRK8tpitLNaD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4ecfaa1a-a2e1-4ef0-a63b-a8ae56763fdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Main Event Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1441 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Family-friendly venue offering bowling, laser tag and arcade games, along with pizza and burgers, plus a ropes course.",
      "poi_long_description": "People say this restaurant offers a variety of entertainment options, including bowling, arcade games, laser tag, and escape rooms, as well as pizza, wings, and drinks. They also highlight the fun atmosphere, suitable for families and birthday parties, and the friendly and helpful staff.\n\nSome reviews mention the games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-c8ef-7035-9896-83834749bc78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-c8ef-7035-9896-83834749bc78",
        "storage_key": "property/6767906449167297/019d270f-c8ef-7035-9896-83834749bc78.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=10621058190493493742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-oklahoma-city",
      "poi_latitude": "35.6102071",
      "poi_longitude": "-97.5381584",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-751-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb5c-77af-ab4c-2d8d8c8bb472.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb5c-77af-ab4c-2d8d8c8bb472",
        "storage_key": "property/6767906449167297/019d270f-fb5c-77af-ab4c-2d8d8c8bb472.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bkHxccsocR7ikexyaUZZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_09ef79ad-420f-466e-aab6-6b9feaa38e89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Penn Square Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1901 Northwest Expy, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Classic enclosed mall with department stores, services & a food court, plus ample parking.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a good food court. They also highlight the fun, laid-back environment and the enjoyable shopping experience.\n\nOther reviews mention the escalators can be out of service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ca73-72a4-badc-9b743dc49380.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-ca73-72a4-badc-9b743dc49380",
        "storage_key": "property/6767906449167297/019d270f-ca73-72a4-badc-9b743dc49380.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/penn-square-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=2811350003534984838&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "penn-square-mall",
      "poi_latitude": "35.5249271",
      "poi_longitude": "-97.5441961",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-842-4424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb2f-701c-8e21-f0e862388899.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb2f-701c-8e21-f0e862388899",
        "storage_key": "property/6767906449167297/019d270f-fb2f-701c-8e21-f0e862388899.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqd3wbBUasocRhvb-2-7rAyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a8123868-7b4b-4416-913b-890a512b4a87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Sprawling shopping center containing retailers, restaurant options & a 24-screen movie theater.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including clothing, shoes, and toys, as well as entertainment options like an arcade, movie theater, and aquarium. They also highlight the clean and safe environment, and the fun atmosphere for families.\n\nOther reviews mention the food court can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-caa9-7385-81eb-a552c820d3b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-caa9-7385-81eb-a552c820d3b9",
        "storage_key": "property/6767906449167297/019d270f-caa9-7385-81eb-a552c820d3b9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb2f-701c-8e21-f0e862388899.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb2f-701c-8e21-f0e862388899",
        "storage_key": "property/6767906449167297/019d270f-fb2f-701c-8e21-f0e862388899.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e241e520-a542-4c16-961c-00c13b3ca6da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 N Western Ave, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic produce, meats, and seafood, as well as unique and hard-to-find items. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ca95-727b-a285-926834c7f263.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-ca95-727b-a285-926834c7f263",
        "storage_key": "property/6767906449167297/019d270f-ca95-727b-a285-926834c7f263.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/oklahomacity?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=551365353270644661&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "35.5340444",
      "poi_longitude": "-97.5305342",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-879-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fd7d-7758-ac27-a102d84e40e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fd7d-7758-ac27-a102d84e40e1",
        "storage_key": "property/6767906449167297/019d270f-fd7d-7758-ac27-a102d84e40e1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeF-rCYasocRtY8nF97Xpgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_288d9f99-3472-4537-8d24-0c0cfaacf189",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6409 Avondale Dr, Nichols Hills, OK 73116, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique, fresh, and organic produce, as well as specialty seasonal items, convenient meals, and gluten-free options. They highlight the reasonable prices, good quality products, and the enjoyable shopping experience. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ce6c-7399-acd0-a5f8f0008803.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-ce6c-7399-acd0-a5f8f0008803",
        "storage_key": "property/6767906449167297/019d270f-ce6c-7399-acd0-a5f8f0008803.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/nichols-hills/461/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6877173602117636080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "35.5376946",
      "poi_longitude": "-97.5310595",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-843-5655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fd7d-7758-ac27-a102d84e40e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fd7d-7758-ac27-a102d84e40e1",
        "storage_key": "property/6767906449167297/019d270f-fd7d-7758-ac27-a102d84e40e1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaTG8SUasocR8E_qTPSgcF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b7930335-1d57-4ad7-9ad4-2c9678cd41df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "3535 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "Shoppers say this grocery store offers a wide variety of bulk items, including coffee beans, spices, and baking supplies, as well as fresh produce, delicious sushi, and a great deli selection. They also highlight the low prices, friendly staff, and clean store.\n\nSome reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-cfa6-726c-a5ed-3853340af6fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-cfa6-726c-a5ed-3853340af6fd",
        "storage_key": "property/6767906449167297/019d270f-cfa6-726c-a5ed-3853340af6fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=888982261208729925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "35.512444",
      "poi_longitude": "-97.5798107",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-832-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fd7d-7758-ac27-a102d84e40e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fd7d-7758-ac27-a102d84e40e1",
        "storage_key": "property/6767906449167297/019d270f-fd7d-7758-ac27-a102d84e40e1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCahmuZoasocRRUn4EqhMVgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ef6280b7-38cc-4562-b22c-d707f1bb51c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Oklahoma Christian University",
      "poi_type": "Education",
      "poi_address": "2501 E Memorial Rd, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-d03f-73eb-9e64-95f8172458c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-d03f-73eb-9e64-95f8172458c0",
        "storage_key": "property/6767906449167297/019d270f-d03f-73eb-9e64-95f8172458c0.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.oc.edu/?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907680163806340117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-christian-university",
      "poi_latitude": "35.6126232",
      "poi_longitude": "-97.4697937",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-425-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb67-76c9-8b05-86aab00a15f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb67-76c9-8b05-86aab00a15f6",
        "storage_key": "property/6767906449167297/019d270f-fb67-76c9-8b05-86aab00a15f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN68XpyQfsocRFWSwsYIC3V8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_32d62317-3e40-4891-a9f4-ce498b735ae1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Belle Isle Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5501 N Villa Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Warm, friendly public library with a children’s area, study rooms and computers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-d033-7426-802a-b15c4db13f0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-d033-7426-802a-b15c4db13f0b",
        "storage_key": "property/6767906449167297/019d270f-d033-7426-802a-b15c4db13f0b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=12135984821329026772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "belle-isle-library---metropolitan-library-system",
      "poi_latitude": "35.52557300000001",
      "poi_longitude": "-97.5569692",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-843-9601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb67-76c9-8b05-86aab00a15f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb67-76c9-8b05-86aab00a15f6",
        "storage_key": "property/6767906449167297/019d270f-fb67-76c9-8b05-86aab00a15f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWXwrG2gasocR1F7ZUuWta6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b525d399-e417-487e-bdee-43d675e35734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Patience S. Latting Northwest Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5600 NW 122nd St, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Modern, welcoming library featuring kid-friendly activities and patios, plus a large selection of books.",
      "poi_long_description": "People say this public library offers a wide selection of books, comics, movies, and CDs, as well as meeting rooms and study spaces. They highlight the spacious, clean, and modern environment, and the relaxing and calming vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-d352-71fa-9c4c-4722e122e508.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-d352-71fa-9c4c-4722e122e508",
        "storage_key": "property/6767906449167297/019d270f-d352-71fa-9c4c-4722e122e508.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6566230327670178026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "patience-s-latting-northwest-library---metropolitan-library-system",
      "poi_latitude": "35.5941759",
      "poi_longitude": "-97.6179217",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-606-3580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb67-76c9-8b05-86aab00a15f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb67-76c9-8b05-86aab00a15f6",
        "storage_key": "property/6767906449167297/019d270f-fb67-76c9-8b05-86aab00a15f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkacMZVEDsocR6oAtkrHvH1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_ef8d06e6-a3a8-4b1b-bc0d-2a4b2fce4521",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including giraffes, gorillas, and elephants, and provides opportunities for interactive experiences like giraffe feeding and stingray petting. They highlight the affordable cost, family-friendly atmosphere, and the active and healthy animals. They also like the friendly and helpful staff, and the clean and well-maintained grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-d4e2-7688-be2e-233b4cfbba73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-d4e2-7688-be2e-233b4cfbba73",
        "storage_key": "property/6767906449167297/019d270f-d4e2-7688-be2e-233b4cfbba73.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.5238895",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_6b86d7dd-a83e-4fe6-8589-a2023624c110",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Science Museum Oklahoma",
      "poi_type": "Entertainment",
      "poi_address": "2020 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_long_description": "People say this science museum offers a wide variety of interactive exhibits, including a planetarium, live shows, and a children's play area. They highlight the educational and engaging experience for all ages, and the spacious layout that prevents overcrowding. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-d580-760a-938a-6540a7dc19ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-d580-760a-938a-6540a7dc19ee",
        "storage_key": "property/6767906449167297/019d270f-d580-760a-938a-6540a7dc19ee.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sciencemuseumok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11678503685854338412&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "science-museum-oklahoma",
      "poi_latitude": "35.5237553",
      "poi_longitude": "-97.4754913",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-602-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa7-7297-b038-54a157c474be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa7-7297-b038-54a157c474be",
        "storage_key": "property/6767906449167297/019d270f-ffa7-7297-b038-54a157c474be.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTLOFjEYsocRbB1wFzphEqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8247229d-944e-4b80-980f-10bda788f25d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "National Cowboy & Western Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "1700 NE 63rd St, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Dioramas, artifacts, art & more documenting & interpreting the history of the American West.",
      "poi_long_description": "Visitors say this museum offers a wealth of Western art and artifacts, including sculptures, paintings, and historical documents, and features engaging exhibits on cowboy culture, Native American history, and the American West. They also highlight the friendly and knowledgeable staff, the family-friendly atmosphere, and the extensive outdoor exhibits, including a recreation of an Old West town.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-d581-7689-997a-9fa826a1a12d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-d581-7689-997a-9fa826a1a12d",
        "storage_key": "property/6767906449167297/019d270f-d581-7689-997a-9fa826a1a12d.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://nationalcowboymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4849781199640138445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "national-cowboy--western-heritage-museum",
      "poi_latitude": "35.5356997",
      "poi_longitude": "-97.4831286",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-478-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa7-7297-b038-54a157c474be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa7-7297-b038-54a157c474be",
        "storage_key": "property/6767906449167297/019d270f-ffa7-7297-b038-54a157c474be.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-cenbQZsocRzRLrSk7iTUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ef996e29-ad70-48cb-9ad1-38298f4c8d1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Frontier City",
      "poi_type": "Entertainment",
      "poi_address": "11501 N I- 35 Service Rd, Oklahoma City, OK 73131, USA",
      "poi_short_description": "Western-themed amusement park offering thrill, kids' & water rides plus multiple shows & eateries.",
      "poi_long_description": "People say this theme park offers a variety of rides, including thrill rides, water rides, and rides for younger children, as well as live shows. They also highlight the park is clean, the staff is friendly, and the lines are short on weekdays.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-d8f9-70b7-8c7b-26447bdc1b88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-d8f9-70b7-8c7b-26447bdc1b88",
        "storage_key": "property/6767906449167297/019d270f-d8f9-70b7-8c7b-26447bdc1b88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/frontiercity",
      "poi_directions_map_url": "https://maps.google.com/?cid=7374031908058551867&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frontier-city",
      "poi_latitude": "35.5856674",
      "poi_longitude": "-97.4394665",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-478-2140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEzIo0KYYsocRO9Y5evPSVWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_f6d0610b-da79-4836-b344-b8f6d27c0fbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Blue Zoo Aquarium Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 125A, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Mall-based attraction featuring sharks, stingrays, snakes and other marine life plus a playground for kids.",
      "poi_long_description": "People say this aquarium offers interactive experiences, including feeding stingrays, birds, and turtles, and petting stingrays. They also highlight the friendly and helpful staff, and the fun play areas for children.\n\nSome reviews mention the facility can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-dac8-734e-8106-b12dac3b5fb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-dac8-734e-8106-b12dac3b5fb0",
        "storage_key": "property/6767906449167297/019d270f-dac8-734e-8106-b12dac3b5fb0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oklahomacity.bluezoo.us/?utm_source=google&utm_medium=organic&utm_campaign=Google+Business+Profile+-+OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242468447430833348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-zoo-aquarium-oklahoma-city",
      "poi_latitude": "35.6125884",
      "poi_longitude": "-97.5573925",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-477-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4zKmxcdsocRxPRO80b9wEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_8dfc8283-b4e3-46ec-ba67-e1385490067f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "2563 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of services, including cardio/weights, group fitness, swimming, tennis, and pickleball. They also highlight the attentive lifeguards, the well-maintained facilities, and the excellent childcare program.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-dacb-73ac-ae39-bdd5a3deea63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-dacb-73ac-ae39-bdd5a3deea63",
        "storage_key": "property/6767906449167297/019d270f-dacb-73ac-ae39-bdd5a3deea63.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/oklahoma-city.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614994550085944548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "35.61423510000001",
      "poi_longitude": "-97.5602129",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-832-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWAnM3kdsocR5ITAcGgt8rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e3cb8773-7e41-41c1-87f6-60ee8e1d879f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "Some gym goers say this gym has a wide variety of equipment, including squat racks, free weights, cardio machines, and a sauna, and they praise the friendly and helpful staff and trainers, particularly Dinafor.\n\nOther reviews mention the gym can be crowded during peak hours and the locker rooms can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-dc8a-743e-bca7-a30afcbe2471.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-dc8a-743e-bca7-a30afcbe2471",
        "storage_key": "property/6767906449167297/019d270f-dc8a-743e-bca7-a30afcbe2471.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city-ok",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ff95ad6c-07e3-4829-89ec-b1445003aa77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Crunch Fitness - Edmond",
      "poi_type": "Health and Wellness",
      "poi_address": "2121 W Danforth Rd, Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cable rigs, benches, leg presses, and powerlifting stations, and has a spacious layout with plenty of cardio machines.\n\nOther reviews mention the restrooms can be poorly maintained and classes can be difficult to book.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-def3-75ef-beff-678a767d9db6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-def3-75ef-beff-678a767d9db6",
        "storage_key": "property/6767906449167297/019d270f-def3-75ef-beff-678a767d9db6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/edmond",
      "poi_directions_map_url": "https://maps.google.com/?cid=8462207099918585172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---edmond",
      "poi_latitude": "35.6692665",
      "poi_longitude": "-97.5106805",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-920-1940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1bUEHcfsocRVI1vzoXMb3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_20bb743b-cf0b-4460-955c-4c170c7eb1fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Oklahoma Gold Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 Technology Dr, Edmond, OK 73013, USA",
      "poi_short_description": "Gym for kids offering classes in gymnastics and tumbling, plus birthday parties.",
      "poi_long_description": "People say this gymnastics center offers a variety of programs, including gymnastics and ninjastics, and hosts fun events like the M&M Olympics. They highlight the positive and encouraging atmosphere, and the personalized attention provided by the coaches. They also like the staff's dedication, professionalism, and genuine care for each child's progress and well-being.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-e107-71a4-b04c-eaff89f8422a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-e107-71a4-b04c-eaff89f8422a",
        "storage_key": "property/6767906449167297/019d270f-e107-71a4-b04c-eaff89f8422a.webp",
        "width": 1280,
        "height": 775
      },
      "poi_business_url": "http://www.oklahomagoldgymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=191096937127623553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-gold-gymnastics",
      "poi_latitude": "35.6263031",
      "poi_longitude": "-97.4926773",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-341-1175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb67-76c9-8b05-86aab00a15f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb67-76c9-8b05-86aab00a15f6",
        "storage_key": "property/6767906449167297/019d270f-fb67-76c9-8b05-86aab00a15f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw7GpO_AesocRgTso36bppgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e978ba95-e3d0-4e17-a7d3-e84d6b139c75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4202 Northwest Expy, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Chain gym offering free high-school memberships, plus tanning beds, massage chairs, and TVs.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and free weights. They also highlight the clean facilities and helpful staff.\n\nOther reviews mention the customer service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-e08a-7716-a441-ffb972e97f1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-e08a-7716-a441-ffb972e97f1e",
        "storage_key": "property/6767906449167297/019d270f-e08a-7716-a441-ffb972e97f1e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-nw-expressway-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17337479712866526724&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.5386202",
      "poi_longitude": "-97.5960525",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-242-4141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWPVatwasocRBGbz4fAZm_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_944ef47e-94cb-46b2-980d-1b7c81356714",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Colaw Fitness of Oklahoma City Gyms",
      "poi_type": "Health and Wellness",
      "poi_address": "3645 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Positive gym, with exercise equipment, tanning beds and massage chairs – plus spiritual wellness.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, tanning beds, and massage chairs. They highlight the affordable membership options, clean facilities, and welcoming atmosphere. They also like the friendly, helpful, and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-e146-7183-9863-4b8c35b8731d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-e146-7183-9863-4b8c35b8731d",
        "storage_key": "property/6767906449167297/019d270f-e146-7183-9863-4b8c35b8731d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colawfitness.com/gyms/oklahoma-city-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8355987367554066829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colaw-fitness-of-oklahoma-city-gyms",
      "poi_latitude": "35.5128276",
      "poi_longitude": "-97.5823903",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-838-1644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0nvVDcbsocRjSm2Jj1u9nM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c78d37e7-0739-44ad-8f33-0294dd510811",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "TB Fit Club | TB Golf | TB Recovery",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of new and modern equipment, including a golf simulator and expanded recovery options, and the staff are helpful and professional.\n\nOther reviews mention the facilities can be poorly maintained and the air conditioning can be inadequate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-e4f4-702b-a098-1013b2f17ff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-e4f4-702b-a098-1013b2f17ff4",
        "storage_key": "property/6767906449167297/019d270f-e4f4-702b-a098-1013b2f17ff4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fit-club--tb-golf--tb-recovery",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ca1feb85-08a6-4b06-80fd-2ab07e1484b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Metro Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "7420 Broadway Ext, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Gymnastics center offering classes and birthday parties for kids of various ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-e600-72ce-ad64-d549cb94d88d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-e600-72ce-ad64-d549cb94d88d",
        "storage_key": "property/6767906449167297/019d270f-e600-72ce-ad64-d549cb94d88d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrogymokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3312655711320854520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-gymnastics",
      "poi_latitude": "35.5464292",
      "poi_longitude": "-97.5132581",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-848-5308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-fb67-76c9-8b05-86aab00a15f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-fb67-76c9-8b05-86aab00a15f6",
        "storage_key": "property/6767906449167297/019d270f-fb67-76c9-8b05-86aab00a15f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSXSRwJwZsocR-M9yeNHq-C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1b7c6b9b-e645-4488-a568-970a3eaf0f47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Scissors & Scotch",
      "poi_type": "Health and Wellness",
      "poi_address": "13230 Pawnee Dr #202, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Upscale barber shop for beard trims and straight-razor shaves alongside a private lounge and a full bar with whisky. Waxing, manicures and massages are also offered.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-e617-73d3-be84-952dea099915.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-e617-73d3-be84-952dea099915",
        "storage_key": "property/6767906449167297/019d270f-e617-73d3-be84-952dea099915.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://scissorsscotch.com/locations/ok/oklahoma-city/chisholm-creek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17460232672315201299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scissors--scotch",
      "poi_latitude": "35.60419",
      "poi_longitude": "-97.5337642",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-486-4902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62z3xRocsocRE1cEcRs1T_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_1e8e920f-fd24-4263-8f22-27bb1577e1ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-e785-716b-94c5-5e8ae9eaabc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-e785-716b-94c5-5e8ae9eaabc2",
        "storage_key": "property/6767906449167297/019d270f-e785-716b-94c5-5e8ae9eaabc2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baptist.integrishealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffb4-757e-9a11-e46c4458ea3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffb4-757e-9a11-e46c4458ea3a",
        "storage_key": "property/6767906449167297/019d270f-ffb4-757e-9a11-e46c4458ea3a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_19005d88-aa35-4430-addf-8d42a81fc82c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-eb31-765e-bee2-d02ec778af99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-eb31-765e-bee2-d02ec778af99",
        "storage_key": "property/6767906449167297/019d270f-eb31-765e-bee2-d02ec778af99.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffb4-757e-9a11-e46c4458ea3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffb4-757e-9a11-e46c4458ea3a",
        "storage_key": "property/6767906449167297/019d270f-ffb4-757e-9a11-e46c4458ea3a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_8cfd9ab8-64fa-4dbb-a5b1-2e7fb45dbd09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Park with trails through woods & grassland, plus amenities including a playground & nature center.",
      "poi_long_description": "People say this park offers beautiful trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the serene and peaceful atmosphere, and the well-maintained grounds. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-eb3b-738b-ac4b-ff899c1cfd62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-eb3b-738b-ac4b-ff899c1cfd62",
        "storage_key": "property/6767906449167297/019d270f-eb3b-738b-ac4b-ff899c1cfd62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d2710-01c8-7256-82e5-a7ace8aa2985.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2710-01c8-7256-82e5-a7ace8aa2985",
        "storage_key": "property/6767906449167297/019d2710-01c8-7256-82e5-a7ace8aa2985.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_70bbd008-3cc8-4b23-8c62-249e62890eae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Will Rogers Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3400 NW 36th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "This year-round park is home to a formal rose garden, walkways, an arboretum & education center.",
      "poi_long_description": "People say this botanical garden offers beautiful, well-maintained gardens, including iris and lily gardens, a lake/creek, and pavilions. They highlight the peaceful and relaxing vibe, and the spacious layout with plenty of photo opportunities. They also like the knowledgeable and patient staff who create engaging workshops. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ec0e-7240-8eeb-a5d4fdecad0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-ec0e-7240-8eeb-a5d4fdecad0a",
        "storage_key": "property/6767906449167297/019d270f-ec0e-7240-8eeb-a5d4fdecad0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/will-rogers-gardens",
      "poi_directions_map_url": "https://maps.google.com/?cid=7664107588336218919&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "will-rogers-gardens",
      "poi_latitude": "35.5069148",
      "poi_longitude": "-97.5770745",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-1394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YeiZYMasocRJ_Mn0z5hXGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_24cc239d-30ad-4152-8107-66729b9dc8c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "This park with a lake boasts a patriotic-themed playground plus baseball fields & a trail.",
      "poi_long_description": "People say this city park offers beautiful scenery, walking trails, a large playground, and panoramic views of the lake. They highlight the park's welcoming and well-kept atmosphere, making it a great place to relax, walk, or enjoy the outdoors. They also like the vibrant energy and family-friendly vibe, and appreciate the police presence for safety.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ed83-731a-805f-50a1a080f3d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-ed83-731a-805f-50a1a080f3d4",
        "storage_key": "property/6767906449167297/019d270f-ed83-731a-805f-50a1a080f3d4.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d2710-01c8-7256-82e5-a7ace8aa2985.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2710-01c8-7256-82e5-a7ace8aa2985",
        "storage_key": "property/6767906449167297/019d2710-01c8-7256-82e5-a7ace8aa2985.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_afa6a4ab-3c26-48ac-95a8-0ed8dabfd4e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Dirt & paved hiking & biking trails wind through a wooded glen, with 3 covered picnic pavilions.",
      "poi_long_description": "Visitors say this park offers well-maintained paved and dirt bike trails, perfect for walking, jogging, and mountain biking, with opportunities to spot wildlife like deer. They also highlight the family-friendly atmosphere with a playground, soccer field, and exercise equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-f035-758d-b483-bd2aa13ff0b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-f035-758d-b483-bd2aa13ff0b3",
        "storage_key": "property/6767906449167297/019d270f-f035-758d-b483-bd2aa13ff0b3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d2710-01c8-7256-82e5-a7ace8aa2985.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2710-01c8-7256-82e5-a7ace8aa2985",
        "storage_key": "property/6767906449167297/019d2710-01c8-7256-82e5-a7ace8aa2985.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6025e676-a138-4e47-9850-d1d93741d472",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Rose Creek Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17031 N May Ave, Edmond, OK 73012, USA",
      "poi_short_description": "Private golf course with an on-site eatery, pickleball courts, a clubhouse and a patio.",
      "poi_long_description": "People say this private golf course offers a great golf course, restaurants, and facilities. They also highlight the amazing staff, beautiful scenery, and good vibes.\n\nOther reviews mention the course conditions can be unchanged.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-f099-717b-9317-246534e665fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-f099-717b-9317-246534e665fb",
        "storage_key": "property/6767906449167297/019d270f-f099-717b-9317-246534e665fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rosecreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897560691660009268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-creek-country-club",
      "poi_latitude": "35.6449907",
      "poi_longitude": "-97.5686808",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-330-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d2710-0422-77fe-b531-c175e3de8788.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2710-0422-77fe-b531-c175e3de8788",
        "storage_key": "property/6767906449167297/019d2710-0422-77fe-b531-c175e3de8788.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8IOAwgdsocRNK83toTEvs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_85efcb4f-0e9a-4199-a85b-65a4416d9425",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-f1bb-765d-bf97-22425e4f8658.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-f1bb-765d-bf97-22425e4f8658",
        "storage_key": "property/6767906449167297/019d270f-f1bb-765d-bf97-22425e4f8658.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_82f00ff3-cd6d-43e5-b255-f2c9606c7258",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Chesapeake Energy Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6100 N Western Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-f454-7398-b40e-0c0727f56751.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-f454-7398-b40e-0c0727f56751",
        "storage_key": "property/6767906449167297/019d270f-f454-7398-b40e-0c0727f56751.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.expandenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3999976576566005612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chesapeake-energy-corporation",
      "poi_latitude": "35.5346273",
      "poi_longitude": "-97.5289016",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-848-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8cjlSYasocRbI8Z7IDFgjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8882b2b0-3a6a-4b3e-9342-60a64235d65c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Love's Corporate Office Building South",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10401 N Pennsylvania Ave, The Village, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-f5f6-7798-b5f9-816e10d55c2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-f5f6-7798-b5f9-816e10d55c2d",
        "storage_key": "property/6767906449167297/019d270f-f5f6-7798-b5f9-816e10d55c2d.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "http://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14437476488466279899&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate-office-building-south",
      "poi_latitude": "35.5768571",
      "poi_longitude": "-97.5501262",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI5qho4IbsocR2y0WjF84XMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ff658f95-70ec-4cdf-a5d7-5ff127af9102",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "CFS Brands",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4711 E Hefner Rd, Oklahoma City, OK 73131, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-f601-70fb-802b-3ad865a096b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-f601-70fb-802b-3ad865a096b6",
        "storage_key": "property/6767906449167297/019d270f-f601-70fb-802b-3ad865a096b6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cfsbrands.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6460468295741084389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cfs-brands",
      "poi_latitude": "35.5808644",
      "poi_longitude": "-97.435523",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-654-8210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZmxMAoisocR5RJSmq8xqFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_930adb3a-373d-4139-b049-6aa16e2f6a69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-f6ec-75d9-bbc4-5a9b81e62c88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270f-f6ec-75d9-bbc4-5a9b81e62c88",
        "storage_key": "property/6767906449167297/019d270f-f6ec-75d9-bbc4-5a9b81e62c88.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270f-ffa1-7569-8714-cd935d1b2615",
        "storage_key": "property/6767906449167297/019d270f-ffa1-7569-8714-cd935d1b2615.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ed0cd127-909b-4104-8662-7f47bc8f56f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Quail Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "11700 Thorn Ridge Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.okcps.org/Domain/34",
      "poi_directions_map_url": "https://maps.google.com/?cid=5934334125062149098&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "quail-creek-elementary-school",
      "poi_latitude": "35.5885984",
      "poi_longitude": "-97.5713615",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-587-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-4094-73ee-b2b0-6c60969be6d7",
        "storage_key": "property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ72UkXX4bsocR6tPO_nH9WlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b1821d21-0448-462c-bfeb-c132b3a4441f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Stonegate Elementary School",
      "poi_type": "Education",
      "poi_address": "2525 NW 112th St, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12482700057558395251&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stonegate-elementary-school",
      "poi_latitude": "35.5841914",
      "poi_longitude": "-97.5603553",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-751-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-4094-73ee-b2b0-6c60969be6d7",
        "storage_key": "property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl-70QIQbsocRcymE8JB1O60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_40cd240b-628d-429f-80a4-0ea7752909d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Ridgeview Elementary School",
      "poi_type": "Education",
      "poi_address": "10010 Ridgeview Dr, The Village, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-4f0b-7172-ac34-b93872aeaf35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-4f0b-7172-ac34-b93872aeaf35",
        "storage_key": "property/6767906449167297/019d7918-4f0b-7172-ac34-b93872aeaf35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okcps.org/Ridgeview",
      "poi_directions_map_url": "https://maps.google.com/?cid=9883859228491310922&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ridgeview-elementary-school",
      "poi_latitude": "35.572391",
      "poi_longitude": "-97.5589732",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-587-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-4094-73ee-b2b0-6c60969be6d7",
        "storage_key": "property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlVFATZgbsocRSucw9JmFKok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_03195ac0-61d8-4dfe-929e-4bc2709a83d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "John Marshall Middle School",
      "poi_type": "Education",
      "poi_address": "2401 NW 115th Terrace, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-4ece-77ec-8f11-c75e20293287.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-4ece-77ec-8f11-c75e20293287",
        "storage_key": "property/6767906449167297/019d7918-4ece-77ec-8f11-c75e20293287.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okcps.org/Domain/24",
      "poi_directions_map_url": "https://maps.google.com/?cid=12695469249844632585&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "john-marshall-middle-school",
      "poi_latitude": "35.5881777",
      "poi_longitude": "-97.5562916",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-587-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-4094-73ee-b2b0-6c60969be6d7",
        "storage_key": "property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm0t9k4gbsocRCVzi7QReL7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7cf80a57-4c4e-431d-b578-c06cb3171dfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Summit Middle School",
      "poi_type": "Education",
      "poi_address": "1703 NW 150th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-4e18-76ae-aabf-6c5ec6496029.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-4e18-76ae-aabf-6c5ec6496029",
        "storage_key": "property/6767906449167297/019d7918-4e18-76ae-aabf-6c5ec6496029.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://summit.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4052681169359623432&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "summit-middle-school",
      "poi_latitude": "35.625296",
      "poi_longitude": "-97.5414836",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-340-2920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-4094-73ee-b2b0-6c60969be6d7",
        "storage_key": "property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJueUCwjkcsocRCFWYLw0EPjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_125f8cbb-239d-4bee-aeeb-f04d0ab94a04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "The Catholic School of St. Eugene",
      "poi_type": "Education",
      "poi_address": "2400 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-4de1-7290-ad4d-380418e044fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-4de1-7290-ad4d-380418e044fb",
        "storage_key": "property/6767906449167297/019d7918-4de1-7290-ad4d-380418e044fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.steugeneschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10217977840465228397&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-catholic-school-of-st-eugene",
      "poi_latitude": "35.5794394",
      "poi_longitude": "-97.5580453",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-751-0067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-4094-73ee-b2b0-6c60969be6d7",
        "storage_key": "property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw98bCpAbsocRbTK-b7WMzY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d6178fc5-256b-40a9-9b71-ec75e9470814",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "John Marshall High School",
      "poi_type": "Education",
      "poi_address": "12201 Portland Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-5324-704b-96fb-b06389881b2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-5324-704b-96fb-b06389881b2d",
        "storage_key": "property/6767906449167297/019d7918-5324-704b-96fb-b06389881b2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okcps.org/Johnmarshall",
      "poi_directions_map_url": "https://maps.google.com/?cid=13761330892857833865&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "john-marshall-high-school",
      "poi_latitude": "35.5932637",
      "poi_longitude": "-97.5882344",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-587-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-4094-73ee-b2b0-6c60969be6d7",
        "storage_key": "property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnV-lOJ8csocRiXlmUYkR-r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0e772502-9e74-4287-8a9a-debd2eac7a4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Heritage Hall",
      "poi_type": "Education",
      "poi_address": "1800 NW 122nd St, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-541c-70f8-ada3-bc6b39f02ee1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-541c-70f8-ada3-bc6b39f02ee1",
        "storage_key": "property/6767906449167297/019d7918-541c-70f8-ada3-bc6b39f02ee1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.heritagehall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7233749162249664118&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "heritage-hall",
      "poi_latitude": "35.591122",
      "poi_longitude": "-97.542737",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-749-3001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-4094-73ee-b2b0-6c60969be6d7",
        "storage_key": "property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp_UYSwgcsocRdrYreolwY2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c3854399-322a-4d55-9c92-f68210fdd342",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Casady School",
      "poi_type": "Education",
      "poi_address": "9500 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-5788-70e9-aaf4-aa598f48b775.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-5788-70e9-aaf4-aa598f48b775",
        "storage_key": "property/6767906449167297/019d7918-5788-70e9-aaf4-aa598f48b775.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.casady.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9825637108673764104&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casady-school",
      "poi_latitude": "35.568469",
      "poi_longitude": "-97.546406",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-749-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-4094-73ee-b2b0-6c60969be6d7",
        "storage_key": "property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP8HoKJUbsocRCFtlUuSsW4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_e8398d82-3608-43fa-863d-e8c47bb8b610",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Oklahoma City University",
      "poi_type": "Education",
      "poi_address": "2501 N Blackwelder Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-5a0b-7230-a393-664e8650149c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-5a0b-7230-a393-664e8650149c",
        "storage_key": "property/6767906449167297/019d7918-5a0b-7230-a393-664e8650149c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=411899583880737593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-university",
      "poi_latitude": "35.4954082",
      "poi_longitude": "-97.540768",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-208-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-4094-73ee-b2b0-6c60969be6d7",
        "storage_key": "property/6767906449167297/019cfb55-4094-73ee-b2b0-6c60969be6d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe7zZY6MQsocRObNXPH1ctwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2b645064-dae5-47e7-9d96-8ad74b8168b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Mahogany Prime Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "3241 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Sophisticated restaurant offering steaks, seafood & creative cocktails in refined surroundings.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, seafood, and sides, including lobster macaroni and cheese and carrot cake. They highlight the generous portions, the attentive and professional staff, and the beautiful ambiance. They also like the accommodating table placement and the thoughtful service that makes guests feel special.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-277d-708f-a01a-af064dd863bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb55-277d-708f-a01a-af064dd863bd",
        "storage_key": "property/6767906449167297/019cfb55-277d-708f-a01a-af064dd863bd.webp",
        "width": 1024,
        "height": 584
      },
      "poi_business_url": "http://mahoganyprimesteakhouse.com/locations/mahogany-oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6052219944289353941&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mahogany-prime-steakhouse",
      "poi_latitude": "35.6103673",
      "poi_longitude": "-97.5755325",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-748-5959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEdl3kYwcsocR1cDmKfnN_VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_2eb9ed8a-763a-41b3-b5e2-1a97b1b18c9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Hopscotch Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "10909 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Homey joint with pool tables & chess games, serving steak, burgers & seafood, plus cocktails & beer.",
      "poi_long_description": "People say this restaurant serves delicious chicken pot pie, meatloaf, and fish and chips. They also highlight the fun vibe with games and pool tables, and the attentive service.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-2354-722b-8134-c17a837f36a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb55-2354-722b-8134-c17a837f36a2",
        "storage_key": "property/6767906449167297/019cfb55-2354-722b-8134-c17a837f36a2.webp",
        "width": 554,
        "height": 558
      },
      "poi_business_url": "http://www.hopscotchokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18057195703532085437&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hopscotch-kitchen-bar",
      "poi_latitude": "35.5811938",
      "poi_longitude": "-97.56757770000002",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-286-4246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ5-YmYIbsocRvWC9PNILmPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_04182d62-1394-407c-aa87-1a177a2704a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Tana Thai Bistro",
      "poi_type": "Restaurants",
      "poi_address": "10700 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Cozy fixture in a strip mall serving traditional Thai dishes in an unpretentious setting.",
      "poi_long_description": "People say this Thai restaurant serves delicious Panang Curry, Pad See Ew, and Thai coffee. They also highlight the attentive and kind service, and the cozy atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-5fc6-7219-90a4-0778a2d9a1da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-5fc6-7219-90a4-0778a2d9a1da",
        "storage_key": "property/6767906449167297/019d7918-5fc6-7219-90a4-0778a2d9a1da.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15700536105955686745&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tana-thai-bistro",
      "poi_latitude": "35.5778461",
      "poi_longitude": "-97.566805",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-242-2075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZbGap0bsocRWfmuQmeC49k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_de6f2de3-43a9-426a-9200-d87b1133b58f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Hacienda Tacos",
      "poi_type": "Restaurants",
      "poi_address": "Shoppes at NorthPark, 12086 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Vibrant, low-key eatery serving Mexican fare such as tacos & quesadillas plus margaritas.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, quesadillas, and nachos. They also highlight the fresh, house-made tortillas, chips, and salsa, and the flavorful, seasoned meats.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-274c-7357-b4e0-a8726781fcf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb55-274c-7357-b4e0-a8726781fcf5",
        "storage_key": "property/6767906449167297/019cfb55-274c-7357-b4e0-a8726781fcf5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://haciendatacos.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=16037182435171725060&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hacienda-tacos",
      "poi_latitude": "35.592613",
      "poi_longitude": "-97.5662696",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-254-3140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfcCRxX8csocRBG-LxnSEj94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_0b7867e4-addb-4494-8597-9fd68fdb7517",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Casa Perico Mexican Grille",
      "poi_type": "Restaurants",
      "poi_address": "11109 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Casual, family-owned option serving standard Mexican fare, cocktails and beer in a colorful space with a patio.",
      "poi_long_description": "Diners say this Mexican restaurant serves up delicious fajitas, carnitas, and habanero salsa. They also highlight the friendly and attentive staff, and the great portions and prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-631e-7318-96df-a4f2a8db9443.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-631e-7318-96df-a4f2a8db9443",
        "storage_key": "property/6767906449167297/019d7918-631e-7318-96df-a4f2a8db9443.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://casaperico.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4166221275886795784&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casa-perico-mexican-grille",
      "poi_latitude": "35.5825875",
      "poi_longitude": "-97.5676184",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-286-2853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_c9uuWEbsocRCDzoRC1k0Tk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_790cf931-bcee-44f9-9fe2-39b12d424f5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Hefner Grill",
      "poi_type": "Restaurants",
      "poi_address": "9201 Lake Hefner Pkwy, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Sophisticated pub grub, steaks & seafood in a waterfront setting with live music & Sunday brunch.",
      "poi_long_description": "People say this seafood restaurant offers delicious lobster rolls, fish tacos, and calamari. They highlight the beautiful lake view, especially at sunset, and the friendly staff. They also like the patio and the live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-6777-714f-8cd1-0ea557d75846.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-6777-714f-8cd1-0ea557d75846",
        "storage_key": "property/6767906449167297/019d7918-6777-714f-8cd1-0ea557d75846.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hefnergrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4950347523357226635&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hefner-grill",
      "poi_latitude": "35.5627444",
      "poi_longitude": "-97.5784278",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-748-6113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-h_NAkbsocRizZxLNgqs0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_cec8f667-d18f-45a8-905f-851829f2f904",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "The Garage Burgers & Beer",
      "poi_type": "Restaurants",
      "poi_address": "2900 W Britton Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Laid-back bar featuring burgers, bison burgers and onion burgers made from scratch, plus beers and fries.",
      "poi_long_description": "People say this hamburger restaurant serves juicy, flavorful burgers with a variety of options, including bison, turkey, and veggie patties, and delicious sides like chili cheese fries and potato bundles. They highlight the fun, lively atmosphere, perfect for watching games, and the reasonable prices. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-68aa-779c-82e5-d278761f479a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-68aa-779c-82e5-d278761f479a",
        "storage_key": "property/6767906449167297/019d7918-68aa-779c-82e5-d278761f479a.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://eatatthegarage.com/locations/the-garage-britton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1801864854338795382&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-garage-burgers-beer",
      "poi_latitude": "35.5653246",
      "poi_longitude": "-97.5677631",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-254-5757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJka4lnaAbsocRdvcf0ImCARk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_e7a8183f-40ea-4f2c-b9d6-366ed9888b88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Uncle Julio's Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1344 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Tex-Mex chain serving mesquite-grilled fare & margarita-sangria swirls in a hacienda-style space.",
      "poi_long_description": "People say this restaurant serves delicious Mexican food, including bacon-wrapped shrimp, fajitas, and enchiladas. They also highlight the fun atmosphere, the delicious chocolate piñata, and the attentive service.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-69f8-74ac-ae1b-b8b425412672.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-69f8-74ac-ae1b-b8b425412672",
        "storage_key": "property/6767906449167297/019d7918-69f8-74ac-ae1b-b8b425412672.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://unclejulios.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6592367220314025478&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "uncle-julio-s-oklahoma-city",
      "poi_latitude": "35.6075896",
      "poi_longitude": "-97.5374138",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-486-0720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4TdSPodsocRBi6_Gw_LfFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0073ed5b-17e6-4d42-971b-5b284241f376",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "2425 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "People say this restaurant serves delicious pizookies, ribeye steak, and mashed potatoes. They also highlight the friendly and attentive staff, and the great dining experience.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-69ab-7038-bcec-bea82a034462.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-69ab-7038-bcec-bea82a034462",
        "storage_key": "property/6767906449167297/019d7918-69ab-7038-bcec-bea82a034462.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/ok/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=16813775833426105589&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bj-s-restaurant-brewhouse",
      "poi_latitude": "35.6103047",
      "poi_longitude": "-97.5578727",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-748-6770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5L30WccsocR9RRpjAmIVuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a48581bf-b18c-4bbb-8b12-1e679b744252",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Black Bear Diner Quail Springs",
      "poi_type": "Restaurants",
      "poi_address": "3015 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Easygoing chain serving familiar all-day comfort food & desserts in a woodsy setting.",
      "poi_long_description": "People say this restaurant serves delicious chicken fried steak, pancakes, and homemade sausage patties. They also highlight the generous portions, reasonable prices, and fun, cozy atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-6e46-7070-9a04-afd8fda44c8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-6e46-7070-9a04-afd8fda44c8b",
        "storage_key": "property/6767906449167297/019d7918-6e46-7070-9a04-afd8fda44c8b.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://blackbeardiner.com/location/quail-springs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10302023260027666703&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "black-bear-diner-quail-springs",
      "poi_latitude": "35.6103497",
      "poi_longitude": "-97.5708111",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-749-5992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ78HkHYscsocRD8HCkZIj-I4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e5d762e7-ca4e-4839-bd23-4513abfdd3de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Kyuramen x TBaar - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "2740 NW 140th St suite F, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Japanese-style eatery serving up ramen and small plates in a casual atmosphere.",
      "poi_long_description": "People say this ramen restaurant serves flavorful ramen, gyoza, and omurice, and offers a variety of boba teas and smoothies. They highlight the unique honeycomb seating, the wish tree, and the overall refreshing atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-7115-72df-b813-bd868e0b4a70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-7115-72df-b813-bd868e0b4a70",
        "storage_key": "property/6767906449167297/019d7918-7115-72df-b813-bd868e0b4a70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kyuramen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13734846288959488399&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kyuramen-x-tbaar-oklahoma-city",
      "poi_latitude": "35.6130422",
      "poi_longitude": "-97.5648326",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-730-6686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yr1kogdsocRj8EF8u35m74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_40d0960f-722c-4240-b466-52c0fdf3fff4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Naan Cuisine of India",
      "poi_type": "Restaurants",
      "poi_address": "12215 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this Indian restaurant serves delicious butter chicken, garlic naan, and chicken tikka masala. They also highlight the generous portions, fresh ingredients, and flavorful, authentic dishes.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-6fca-7779-bbc7-d0f0a704fe2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-6fca-7779-bbc7-d0f0a704fe2c",
        "storage_key": "property/6767906449167297/019d7918-6fca-7779-bbc7-d0f0a704fe2c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.naancuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5922812203573884507&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "naan-cuisine-of-india",
      "poi_latitude": "35.5941025",
      "poi_longitude": "-97.5509483",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-752-5283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUDnG3cdsocRW7ZemVEOMlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_41a7bfcc-3bed-4da8-b15f-866ee2328d67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Hatch Early Mood Food",
      "poi_type": "Restaurants",
      "poi_address": "13230 Pawnee Dr Suite 112, Oklahoma City, OK 73114, USA",
      "poi_short_description": "High-ceilinged space with an industrial-chic vibe serving all-day breakfast fare plus lunch bites.",
      "poi_long_description": "People say this brunch restaurant serves tasty food, including decadent specialty pancakes and delicious waffles. They also highlight the friendly staff, quick service, and upbeat, appealing atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-717e-7780-9fab-2b5c07ba82c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-717e-7780-9fab-2b5c07ba82c6",
        "storage_key": "property/6767906449167297/019d7918-717e-7780-9fab-2b5c07ba82c6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hatchearlymoodfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8334602234314933719&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hatch-early-mood-food",
      "poi_latitude": "35.604193",
      "poi_longitude": "-97.5340069",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-286-2974",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a8-769c-b094-a32b58d0694e",
        "storage_key": "property/6767906449167297/019cfb55-40a8-769c-b094-a32b58d0694e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJod1fxhocsocR18WE0JJ0qnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_10675946-cbbc-4061-89bb-22852b1ba1c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "13601 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "People say this coffee shop has a convenient drive-thru and offers popular drinks like chai tea and pink drinks. They also highlight the friendly staff and efficient service.\n\nSome reviews mention the drinks can be made incorrectly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-7617-715f-9c8b-e6d656a2d670.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-7617-715f-9c8b-e6d656a2d670",
        "storage_key": "property/6767906449167297/019d7918-7617-715f-9c8b-e6d656a2d670.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.ca/store-locator/store/1030994/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2217484800767464764&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "35.60814",
      "poi_longitude": "-97.56787",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-754-1023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-c1e6-7633-8c61-468a19e4d7b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7918-c1e6-7633-8c61-468a19e4d7b2",
        "storage_key": "property/6767906449167297/019d7918-c1e6-7633-8c61-468a19e4d7b2.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ-RQ2vXEdsocRPJWSdK0Wxh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_983e6890-92a1-4310-9a7e-3f67d18dcde8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Teapioca Lounge",
      "poi_type": "Restaurants",
      "poi_address": "13415 N Pennsylvania Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Modern hangout with a wide range of cream teas, coffee & smoothies, plus desserts & board games.",
      "poi_long_description": "Modern hangout with a wide range of cream teas, coffee & smoothies, plus desserts & board games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-765d-70a0-903d-72bdc86f37d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-765d-70a0-903d-72bdc86f37d5",
        "storage_key": "property/6767906449167297/019d7918-765d-70a0-903d-72bdc86f37d5.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.teapiocalounge.com/teapioca-quail-springs-oklahoma-city-boba-tea",
      "poi_directions_map_url": "https://maps.google.com/?cid=18377513644293000482&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "teapioca-lounge",
      "poi_latitude": "35.6064157",
      "poi_longitude": "-97.5498631",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-849-6981",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a9-70e8-9229-44f16f76b606",
        "storage_key": "property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7SVQmwcsocRIo36jkoLCv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tea_house"
    },
    {
      "id": "custom_abb9fc46-bdcd-4a73-8e3b-2a4ac4630a21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Shoppes at Northpark",
      "poi_type": "Shopping & Retail",
      "poi_address": "12100 N May Ave, Oklahoma City, OK 73156, USA",
      "poi_short_description": "Shopping complex showcasing shops, from kidswear to jewelry, plus eateries and a movie theater.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-79ef-733f-a165-ac5ccd41c4aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-79ef-733f-a165-ac5ccd41c4aa",
        "storage_key": "property/6767906449167297/019d7918-79ef-733f-a165-ac5ccd41c4aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northparkokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10911568943014137873&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "shoppes-at-northpark",
      "poi_latitude": "35.591473",
      "poi_longitude": "-97.566083",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-410c-77a2-b67f-aa9af02f3edf",
        "storage_key": "property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU0-WkH8csocREdCKRiSubZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_faef982a-228b-495e-b567-d215d38706f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "The Market at Quail Springs",
      "poi_type": "Shopping & Retail",
      "poi_address": "12202 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-7b8f-7499-92c4-f9969d022be7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-7b8f-7499-92c4-f9969d022be7",
        "storage_key": "property/6767906449167297/019d7918-7b8f-7499-92c4-f9969d022be7.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5054793782763140957&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-market-at-quail-springs",
      "poi_latitude": "35.5936682",
      "poi_longitude": "-97.5662446",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-752-2377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-410c-77a2-b67f-aa9af02f3edf",
        "storage_key": "property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_2q1qmAcsocRXTdz-ik8JkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e2dfd5bf-323f-43d8-a550-fee1b4f800fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Casady Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "9327 N Pennsylvania Ave, The Village, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-7d7e-774d-b02b-7f7a4d84eae9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-7d7e-774d-b02b-7f7a4d84eae9",
        "storage_key": "property/6767906449167297/019d7918-7d7e-774d-b02b-7f7a4d84eae9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://casadysquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1395385190476482281&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casady-square",
      "poi_latitude": "35.5652787",
      "poi_longitude": "-97.5512342",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-752-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-410c-77a2-b67f-aa9af02f3edf",
        "storage_key": "property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFckuw74bsocR6QYxC3BnXRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_85218f1e-44a8-4120-b41c-b6bd778dbd6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this warehouse club offers a wide variety of goods, including fresh produce and bakery items. They also highlight the convenient layout, spacious aisles, and clean environment, as well as the helpful staff and easy parking.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-7f2a-7320-9428-542be7102519.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-7f2a-7320-9428-542be7102519",
        "storage_key": "property/6767906449167297/019d7918-7f2a-7320-9428-542be7102519.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.samsclub.com/club/8117-oklahoma-city-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=9968560549527357001&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club",
      "poi_latitude": "35.6071604",
      "poi_longitude": "-97.5462298",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-748-7109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-410c-77a2-b67f-aa9af02f3edf",
        "storage_key": "property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ30O3VGscsocRSQaNDAFxV4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_89284727-2be7-4d1e-9a23-1b4958229000",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "13924 N Pennsylvania Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of home decor and holiday items. They also highlight the polite and helpful staff.\n\nOther reviews mention the checkout process can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-83a0-767e-9680-27eb37bbcb60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-83a0-767e-9680-27eb37bbcb60",
        "storage_key": "property/6767906449167297/019d7918-83a0-767e-9680-27eb37bbcb60.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/quail-springs/1397",
      "poi_directions_map_url": "https://maps.google.com/?cid=3776845119011340636&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.6124909",
      "poi_longitude": "-97.5467606",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-752-0183",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-410c-77a2-b67f-aa9af02f3edf",
        "storage_key": "property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe5CavWocsocRXMFWCqAMajQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_6976cb44-3ed9-4e1e-963d-d9b7e611b264",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of plants, flowers, yard decor, and building supplies. They also highlight the helpful and knowledgeable staff, and the organized aisles.\n\nOther reviews mention the return policy can be restrictive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-8292-76f9-bacc-81acf548c808.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-8292-76f9-bacc-81acf548c808",
        "storage_key": "property/6767906449167297/019d7918-8292-76f9-bacc-81acf548c808.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Oklahoma-City/0535?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-535-_-na-_-0-_-0&y_source=1_MTE4MzI1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9854502234558219169&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowe-s-home-improvement",
      "poi_latitude": "35.606458",
      "poi_longitude": "-97.556346",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-936-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-410c-77a2-b67f-aa9af02f3edf",
        "storage_key": "property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ80ErRm8csocRocMiKZI5wog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_87b9634f-0a42-4ebf-bbd1-83ad582b2079",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Living Spaces",
      "poi_type": "Shopping & Retail",
      "poi_address": "13502 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Retailer offering home furnishings, including sofas and mattresses, along with lighting and rugs.",
      "poi_long_description": "People say this furniture store offers a wide selection of furniture, including indoor and outdoor options, and a variety of styles and price points. They highlight the no-pressure shopping experience, the knowledgeable and helpful staff, and the quick and easy purchase process. They also like the clean and spacious store, and the kid-friendly amenities, such as a play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-8839-710c-853b-236774560ff3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-8839-710c-853b-236774560ff3",
        "storage_key": "property/6767906449167297/019d7918-8839-710c-853b-236774560ff3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.livingspaces.com/stores/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=15621851924853391165&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "living-spaces",
      "poi_latitude": "35.6066757",
      "poi_longitude": "-97.5652534",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 877-266-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-410c-77a2-b67f-aa9af02f3edf",
        "storage_key": "property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuacSt-gVsocRPX-juo73y9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_ab8e1d5b-0742-4ce2-bdbe-6c629c7eb1f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "13800 N May Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "People say this book store offers a great variety of books, manuals, games, toys, and music, and they appreciate the friendly and helpful staff. They also highlight the clean and well-organized space, making it a comfortable place to browse and relax.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-8b9e-729e-85e4-5c7146ebdc5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-8b9e-729e-85e4-5c7146ebdc5d",
        "storage_key": "property/6767906449167297/019d7918-8b9e-729e-85e4-5c7146ebdc5d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2725",
      "poi_directions_map_url": "https://maps.google.com/?cid=4169269107419554585&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barnes-noble",
      "poi_latitude": "35.6111781",
      "poi_longitude": "-97.5664656",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-755-1155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-410c-77a2-b67f-aa9af02f3edf",
        "storage_key": "property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa7GFOmAcsocRGaPA2Ck43Dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_ad067900-c4f3-4a27-a943-d2699c2b04ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Dillard's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd #1001, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Department store chain with apparel, shoes & accessories, plus beauty products & home goods.",
      "poi_long_description": "People say this department store offers a wide selection of merchandise. They also highlight the outstanding customer service and helpful staff.\n\nOther reviews mention the sales people can be pushy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-8bc2-7304-8189-5777094cd133.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-8bc2-7304-8189-5777094cd133",
        "storage_key": "property/6767906449167297/019d7918-8bc2-7304-8189-5777094cd133.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.dillards.com/stores/oklahoma/quail-springs-mall-oklahoma-city/0795",
      "poi_directions_map_url": "https://maps.google.com/?cid=18409991828866666490&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dillard-s",
      "poi_latitude": "35.6134841",
      "poi_longitude": "-97.5574241",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-755-5220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-410c-77a2-b67f-aa9af02f3edf",
        "storage_key": "property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR-g9xLQduff8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f64bb330-9df9-4f58-b618-1e4c0b4671a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "13301 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a great selection of groceries and affordable prices. They highlight the good value and clean stores. They also like the kind employees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-8d90-731d-9005-cbb680a7b735.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-8d90-731d-9005-cbb680a7b735",
        "storage_key": "property/6767906449167297/019d7918-8d90-731d-9005-cbb680a7b735.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/oklahoma-city/13301-n-penn-ave/l795",
      "poi_directions_map_url": "https://maps.google.com/?cid=15333548337638368253&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.605264",
      "poi_longitude": "-97.5505023",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-409e-77fb-834f-1c36eb2cd38d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-409e-77fb-834f-1c36eb2cd38d",
        "storage_key": "property/6767906449167297/019cfb55-409e-77fb-834f-1c36eb2cd38d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVJVDyA134cR_WM38_i0y9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_983dbcff-d611-4889-9851-cb2f1f8fd62f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Department store carrying a wide range of merchandise, including electronics, home appliances, and groceries.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, home goods, and electronics, and provides convenient services like delivery and online pickup.\n\nOther reviews mention the service can be slow and the store can be understaffed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-9537-73cf-86b4-55ec0d592682.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-9537-73cf-86b4-55ec0d592682",
        "storage_key": "property/6767906449167297/019d7918-9537-73cf-86b4-55ec0d592682.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1626-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10140810101618845328&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.6052952",
      "poi_longitude": "-97.5460685",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-752-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-410c-77a2-b67f-aa9af02f3edf",
        "storage_key": "property/6767906449167297/019cfb55-410c-77a2-b67f-aa9af02f3edf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-WNQUWscsocRkCavIQ9lu4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_15d85414-4ffa-4990-b988-3e8df706670b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "AMC Quail Springs Mall 24",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite E, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Recliner-seat theater, in a mall, featuring 3D movies and an IMAX screen.",
      "poi_long_description": "People say this movie theater offers a wide variety of movies, including IMAX and Dolby Digital screenings, and the screens are in good condition. They also highlight the friendly and fast service, and the clean theaters and bathrooms.\n\nOther reviews mention the seats can be uncomfortable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-9857-7169-abb2-db32c86947c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-9857-7169-abb2-db32c86947c8",
        "storage_key": "property/6767906449167297/019d7918-9857-7169-abb2-db32c86947c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/oklahoma-city/amc-quail-springs-mall-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12403470034805982991&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-quail-springs-mall-24",
      "poi_latitude": "35.6122375",
      "poi_longitude": "-97.5583891",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-755-2466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-410c-77a2-b67f-a756703f10ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-410c-77a2-b67f-a756703f10ea",
        "storage_key": "property/6767906449167297/019cfb55-410c-77a2-b67f-a756703f10ea.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvaQTZ2ccsocRDwfQvkf6Iaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_907f873a-ddd8-41cf-a2de-fde1dfe6c298",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Quail Creek Golf & Country Club",
      "poi_type": "Entertainment",
      "poi_address": "3501 Quail Creek Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Upscale facility, owned by members, featuring golf courses and tennis courts, plus a pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-9c44-74fc-a54d-a0ba1bc6b912.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-9c44-74fc-a54d-a0ba1bc6b912",
        "storage_key": "property/6767906449167297/019d7918-9c44-74fc-a54d-a0ba1bc6b912.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.quailcreekgcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3160679487445955446&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "quail-creek-golf-country-club",
      "poi_latitude": "35.5992235",
      "poi_longitude": "-97.5817331",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-751-0811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a9-70e8-9229-44f16f76b606",
        "storage_key": "property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJdotho8csocRdnMUcj_93Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_ec36b76a-0a46-458e-8fd7-b819bac9093c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Art Central",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 127, Oklahoma City, OK 73134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-9bf2-708b-91ee-ac92ce9f4122.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-9bf2-708b-91ee-ac92ce9f4122",
        "storage_key": "property/6767906449167297/019d7918-9bf2-708b-91ee-ac92ce9f4122.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.artcentralok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3721249190432238178&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "art-central",
      "poi_latitude": "35.6124532",
      "poi_longitude": "-97.5572141",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a9-70e8-9229-44f16f76b606",
        "storage_key": "property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjSacHWMdsocRYmpsNGyIpDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "custom_08f40953-cb8b-4c81-a909-b5598ae8baab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Breakout Games",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd #227, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Team-building escape room venue featuring puzzle-filled scenarios and themed challenges.",
      "poi_long_description": "People say this escape room center offers a variety of fun and challenging rooms, including Runaway Train, Kidnapping, and Museum Heist. They highlight the puzzles are varied and have a high level of difficulty, and the rooms are well-decorated and interactive. They also like that the games are designed for private groups, allowing friends and family to play together.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-a642-742b-a8f9-67bfe9368a31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-a642-742b-a8f9-67bfe9368a31",
        "storage_key": "property/6767906449167297/019d7918-a642-742b-a8f9-67bfe9368a31.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.breakoutgames.com/oklahoma-city?utm_source=google&utm_medium=organic&utm_campaign=gmb-oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=1439416862903744307&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "breakout-games",
      "poi_latitude": "35.612875",
      "poi_longitude": "-97.557172",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-731-9192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a9-70e8-9229-44f16f76b606",
        "storage_key": "property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr8jzfGccsocRM7cVrQLW-RM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_f8094437-dd3b-40f2-9bde-8b693d681d76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Louis A. Macklanburg Park",
      "poi_type": "Entertainment",
      "poi_address": "2234 NW 117th St, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Community space featuring basketball courts, baseball fields, a splash pad and a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-ac67-7245-b3ec-834feb519fce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-ac67-7245-b3ec-834feb519fce",
        "storage_key": "property/6767906449167297/019d7918-ac67-7245-b3ec-834feb519fce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2477714902537381353&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "louis-a-macklanburg-park",
      "poi_latitude": "35.5882595",
      "poi_longitude": "-97.5526464",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-43c2-7579-baa7-2ea94ca29ffd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-43c2-7579-baa7-2ea94ca29ffd",
        "storage_key": "property/6767906449167297/019cfb55-43c2-7579-baa7-2ea94ca29ffd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy7bccIkbsocR6aVujJOcYiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_85b84672-adf9-4535-99d5-1d16b41b91f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Lake Hefner",
      "poi_type": "Entertainment",
      "poi_address": "Lake Hefner, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5400634991969834440&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lake-hefner",
      "poi_latitude": "35.5769492",
      "poi_longitude": "-97.5768652",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a9-70e8-9229-44f16f76b606",
        "storage_key": "property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXY-RLXIbsocRyBXoUeno8ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d359be6a-1117-4a83-bd35-f26476cc467d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "North Britton Park",
      "poi_type": "Entertainment",
      "poi_address": "Oklahoma City, OK 73114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14241348963601168679&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "north-britton-park",
      "poi_latitude": "35.5884029",
      "poi_longitude": "-97.5406333",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-43c2-7579-baa7-2ea94ca29ffd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-43c2-7579-baa7-2ea94ca29ffd",
        "storage_key": "property/6767906449167297/019cfb55-43c2-7579-baa7-2ea94ca29ffd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqnvYbsocRJznTsW1vo8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bae92d61-289d-424b-9efe-6f2bc474c864",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "iFLY Indoor Skydiving - Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "13600 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Indoor skydiving center flying kids and adults in a vertical wind tunnel, also offering birthday parties and corporate outings.",
      "poi_long_description": "People say this skydiving center offers a thrilling and unforgettable indoor skydiving experience. They highlight the fun, easy, and exciting atmosphere, and the patient, upbeat, and reassuring instructors. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019d7918-a9cb-72d8-bed3-6412be55130b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-a9cb-72d8-bed3-6412be55130b",
        "storage_key": "property/6767906449167297/019d7918-a9cb-72d8-bed3-6412be55130b.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.iflyworld.com/oklahoma-city/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13546701854073548325&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ifly-indoor-skydiving-oklahoma-city",
      "poi_latitude": "35.607959",
      "poi_longitude": "-97.53839",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-300-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb55-40a9-70e8-9229-44f16f76b606",
        "storage_key": "property/6767906449167297/019cfb55-40a9-70e8-9229-44f16f76b606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRw5s2xYcsocRJe4tEpCN_7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_162b5fe1-929a-408e-a01d-0fcdda93946c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Yokozuna OKC",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "yokozuna-okc",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_29089073-c11d-4a28-95a3-8d80664cdf01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Corner Bakery Cafe",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "corner-bakery-cafe",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2b938720-1674-481e-a715-a4491cf3ff57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Coffee Jerks",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "coffee-jerks",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_adfc59ee-65e8-46ff-a40d-25fd61e55898",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "poi_name": "Uptown Grocery Co.",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "uptown-grocery-co",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_c5640f354d185a16ebf7ef85",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2472c13bae03b2020db096bd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_36743ebb71be4481992cd809",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f7f9509086f237a3244317ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_caf0cd34a39f83716139cf26",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_2747bb4631c992f886e49d2c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_492423b9b4116f60efaa71f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "custom_761b3708-bfd5-415c-aaf0-f15dc9702bf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-de8b-758a-87d6-1a93a86b5fd6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a modern apartment kitchen with island and stainless steel appliances.",
        "public_id": "019cfb55-de8b-758a-87d6-1a93a86b5fd6",
        "storage_key": "property/6767906449167297/019cfb55-de8b-758a-87d6-1a93a86b5fd6.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Chisholm Pointe Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6965bca040714d17cae3fbc3&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-7edf-76cc-b077-d5d3bb9913a0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "summit-ridge-villas",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297"
    },
    {
      "lead_collector_id": "019cf79e-7f55-72ce-9955-9be5266ae73f",
      "lead_source": "LANDING_PAGE",
      "name": "summit-ridge-villas",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-northwest-okc",
      "search_query": "pet friendly apartments with dog park in Northwest Oklahoma City",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Northwest OKC",
      "h2_subtitle": "Looking for pet friendly apartments with a dog park? Summit Ridge Villas offers a pet play area in Northwest Oklahoma City for your furry friends.",
      "page_copy": "At Summit Ridge Villas, we understand that pets are family. That's why we welcome you and your four-legged companions to explore our pet-friendly apartments nestled in the heart of Northwest Oklahoma City. Our community features a dedicated pet play area where your furry friends can stretch their legs and enjoy some off-leash fun. \n\nSituated in vibrant Oklahoma County, Summit Ridge Villas offers more than just beautiful apartments. Each home is equipped with modern amenities like dishwashers, heating, and ceiling fans, along with private fenced yards. Plus, with our fabulous dog play area, your pets will feel right at home. Come experience the pet-friendly lifestyle at Summit Ridge Villas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
      "featured_image_media": {
        "alt_text": "Summit Villas logo",
        "public_id": "019cfb54-f460-771f-b11b-25b5156666b5",
        "storage_key": "property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
        "width": 1067,
        "height": 516
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Northwest OKC",
      "seo_description": "Discover pet-friendly apartments with a dog park in NW Oklahoma City. Summit Ridge Villas offers amenities perfect for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "generator",
      "page_item_url": "energy-efficient-apartments-stainless-appliances-okc",
      "search_query": "energy-efficient stainless appliances apartments OKC",
      "category": "Amenity",
      "h1_title": "Energy-Efficient Apartments in OKC",
      "h2_subtitle": "Searching for energy-efficient stainless appliances apartments in OKC? Discover Summit Ridge Villas and its modern features.",
      "page_copy": "Summit Ridge Villas in Northwest Oklahoma City proudly offers energy-efficient apartments furnished with stainless steel appliances. These modern amenities help you reduce your carbon footprint while enhancing your living experience within our vibrant community. \n\nLocated in the heart of Northwest Oklahoma City, Summit Ridge Villas combines style and sustainability. Not only do you benefit from energy-efficient stainless appliances, but our community also offers conveniences such as ceiling fans, heating, and private fenced yards. Enjoy a comfortable and eco-friendly lifestyle at Summit Ridge Villas today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
      "featured_image_media": {
        "alt_text": "Summit Villas logo",
        "public_id": "019cfb54-f460-771f-b11b-25b5156666b5",
        "storage_key": "property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
        "width": 1067,
        "height": 516
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy-Efficient Apartments in OKC",
      "seo_description": "Explore energy-efficient apartments in OKC with stainless appliances. Summit Ridge Villas offers modern living with eco-friendly features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "generator",
      "page_item_url": "apartments-fenced-yards-oklahoma-county",
      "search_query": "apartments with fenced yards Oklahoma County",
      "category": "Amenity",
      "h1_title": "Apartments with Fenced Yards in OK County",
      "h2_subtitle": "Need apartments with fenced yards in Oklahoma County? Summit Ridge Villas provides spacious living with private outdoor areas.",
      "page_copy": "Summit Ridge Villas, located in the charming neighborhood of Northwest Oklahoma City, offers the perfect solution for those seeking apartments with fenced yards in Oklahoma County. Our homes are designed to provide a private and secure outdoor space where you can relax and unwind.\n\nEnjoy the freedom of having your own fenced yard while benefiting from the community amenities like a pet play area, heating, and modern kitchens equipped with dishwashers. At Summit Ridge Villas, we cater to your desire for more personal outdoor space, making it an ideal choice for families and pet lovers alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
      "featured_image_media": {
        "alt_text": "Summit Villas logo",
        "public_id": "019cfb54-f460-771f-b11b-25b5156666b5",
        "storage_key": "property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
        "width": 1067,
        "height": 516
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fenced Yards in OK County",
      "seo_description": "Find apartments with fenced yards in Oklahoma County at Summit Ridge Villas, offering spacious living and modern amenities including a pet play area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "generator",
      "page_item_url": "wifi-ready-apartments-northwest-oklahoma-city",
      "search_query": "WiFi ready apartments Northwest Oklahoma City",
      "category": "Amenity",
      "h1_title": "WiFi Ready Apartments in NW OKC",
      "h2_subtitle": "Looking for WiFi ready apartments in Northwest Oklahoma City? Summit Ridge Villas provides seamless connectivity in a prime location.",
      "page_copy": "Discover the convenience of WiFi ready apartments at Summit Ridge Villas, ideally situated in Northwest Oklahoma City. Our community ensures that you're always connected, whether you're working from home or streaming your favorite shows.\n\nResidents enjoy a lifestyle enriched with amenities, including contemporary kitchens with dishwashers, fenced yards, and a dog-friendly play area. Located in the heart of Oklahoma County, Summit Ridge Villas offers an ideal blend of connectivity and comfort in a vibrant neighborhood. Experience hassle-free internet access and more in your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
      "featured_image_media": {
        "alt_text": "Summit Villas logo",
        "public_id": "019cfb54-f460-771f-b11b-25b5156666b5",
        "storage_key": "property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
        "width": 1067,
        "height": 516
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "WiFi Ready Apartments in NW OKC",
      "seo_description": "Enjoy seamless connectivity at Summit Ridge Villas, offering WiFi ready apartments in Northwest Oklahoma City with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "generator",
      "page_item_url": "apartments-with-balcony-oklahoma-city-73120",
      "search_query": "apartments with balcony Oklahoma City 73120",
      "category": "Amenity",
      "h1_title": "Apartments with Balcony in OKC 73120",
      "h2_subtitle": "Seeking apartments with balcony in Oklahoma City? Summit Ridge Villas in the 73120 area offers fantastic outdoor spaces.",
      "page_copy": "At Summit Ridge Villas, located in the vibrant 73120 area of Oklahoma City, residents can enjoy apartments with spacious balconies perfect for outdoor relaxation. Taking in the fresh air and scenic views from your own balcony becomes a daily pleasure in our community.\n\nOur apartments are designed to enhance your lifestyle with features including modern kitchens with efficient dishwashers, ceiling fans for added comfort, and private fenced yards. Come home to a community that values outdoor living and comfort right in the heart of Northwest Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
      "featured_image_media": {
        "alt_text": "Summit Villas logo",
        "public_id": "019cfb54-f460-771f-b11b-25b5156666b5",
        "storage_key": "property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
        "width": 1067,
        "height": 516
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Balcony in OKC 73120",
      "seo_description": "Explore Summit Ridge Villas for apartments with balconies in Oklahoma City 73120. Enjoy outdoor spaces and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-nw-oklahoma-city",
      "search_query": "two bedroom apartments northwest oklahoma city",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in NW Oklahoma City",
      "h2_subtitle": "Searching for two bedroom apartments in Northwest Oklahoma City? Discover the spacious and comfortable options at Summit Ridge Villas.",
      "page_copy": "Summit Ridge Villas offers spacious two bedroom apartments in Northwest Oklahoma City, ideal for families or roommates seeking ample living space. Each unit is thoughtfully designed with modern amenities, including a well-equipped kitchen featuring a dishwasher and ceiling fans for year-round comfort.\n\nResidents appreciate the private fenced yards, perfect for personal relaxation or entertaining guests. Our location in the heart of Oklahoma County means you're close to shopping, dining, and entertainment. Experience a welcoming community environment with the convenience of major city attractions nearby.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
      "featured_image_media": {
        "alt_text": "Summit Villas logo",
        "public_id": "019cfb54-f460-771f-b11b-25b5156666b5",
        "storage_key": "property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
        "width": 1067,
        "height": 516
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in NW OKC",
      "seo_description": "Find spacious two bedroom apartments in Northwest Oklahoma City at Summit Ridge Villas, featuring modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "generator",
      "page_item_url": "apartments-near-oklahoma-christian-university-okc",
      "search_query": "apartments near Oklahoma Christian University Oklahoma City",
      "category": "School",
      "h1_title": "Apartments Near Oklahoma Christian University",
      "h2_subtitle": "Looking for apartments near Oklahoma Christian University? Summit Ridge Villas offers comfortable living just a short drive from the campus.",
      "page_copy": "Located conveniently close to Oklahoma Christian University, Summit Ridge Villas provides the perfect home base for students and faculty. Our apartments offer easy access to the university and a comfortable living environment with a range of amenities.\n\nResidents benefit from features like spacious layouts, modern kitchens with dishwashers, and ceiling fans for a cozy home atmosphere. Enjoy the community pet play area and fenced yards that complement the balance of work, study, and relaxation. Experience stress-free commutes and enriching campus life while residing at Summit Ridge Villas in Northwest Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
      "featured_image_media": {
        "alt_text": "Summit Villas logo",
        "public_id": "019cfb54-f460-771f-b11b-25b5156666b5",
        "storage_key": "property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
        "width": 1067,
        "height": 516
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oklahoma Christian University",
      "seo_description": "Discover comfortable apartments near Oklahoma Christian University at Summit Ridge Villas, offering modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "generator",
      "page_item_url": "apartments-near-mercy-hospital-oklahoma-city",
      "search_query": "apartments near Mercy Hospital Oklahoma City",
      "category": "Hospital",
      "h1_title": "Apartments Near Mercy Hospital OKC",
      "h2_subtitle": "Looking for convenient apartments near Mercy Hospital in Oklahoma City? Summit Ridge Villas offers the ideal location and amenities.",
      "page_copy": "Summit Ridge Villas provides comfortable living options conveniently located near Mercy Hospital in Oklahoma City. Perfect for healthcare professionals and families, our community offers ease of access and modern accommodations.\n\nEach apartment features desirable amenities such as equipped kitchens with dishwashers, ceiling fans for enhanced comfort, and pet-friendly fenced yards. Situated in Northwest Oklahoma City, our community ensures quick commutes and all the comforts of home, allowing you to focus on work and relaxation seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
      "featured_image_media": {
        "alt_text": "Summit Villas logo",
        "public_id": "019cfb54-f460-771f-b11b-25b5156666b5",
        "storage_key": "property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
        "width": 1067,
        "height": 516
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mercy Hospital OKC",
      "seo_description": "Find convenient apartments near Mercy Hospital in Oklahoma City at Summit Ridge Villas. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "generator",
      "page_item_url": "apartments-near-martin-park-nature-center-okc",
      "search_query": "apartments near Martin Park Nature Center Oklahoma City",
      "category": "Park",
      "h1_title": "Apartments Near Martin Park Nature Center",
      "h2_subtitle": "Explore tranquil living with our apartments near Martin Park Nature Center in Oklahoma City. Enjoy nature right at your doorstep at Summit Ridge Villas.",
      "page_copy": "Summit Ridge Villas offers a serene living environment with our apartments situated near the beautiful Martin Park Nature Center in Oklahoma City. Perfect for nature enthusiasts and families, our location provides easy access to outdoor adventures while enjoying a comfortable home setting.\n\nResidents can indulge in modern amenities like kitchens with dishwashers, ceiling fans, and private fenced yards ideal for leisure and pets. Nestled in Northwest Oklahoma City, Summit Ridge Villas combines the tranquility of nearby nature with the conveniences of modern living and urban accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
      "featured_image_media": {
        "alt_text": "Summit Villas logo",
        "public_id": "019cfb54-f460-771f-b11b-25b5156666b5",
        "storage_key": "property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
        "width": 1067,
        "height": 516
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Martin Park Nature Center",
      "seo_description": "Discover peaceful living at Summit Ridge Villas, near Martin Park Nature Center in OKC. Enjoy modern comfort in a natural setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "generator",
      "page_item_url": "apartments-close-to-will-rogers-gardens-nw-okc",
      "search_query": "apartments close to Will Rogers Gardens Northwest OKC",
      "category": "Park",
      "h1_title": "Apartments Close to Will Rogers Gardens",
      "h2_subtitle": "Discover our charming apartments close to Will Rogers Gardens in Northwest OKC. Summit Ridge Villas blends convenience with natural beauty.",
      "page_copy": "Nestled in Northwest OKC, Summit Ridge Villas offers excellent proximity to the picturesque Will Rogers Gardens. Our apartments provide the perfect balance of urban convenience and natural beauty, ideal for those who appreciate outdoor activities and peaceful surroundings.\n\nResidents enjoy well-appointed homes featuring modern kitchens complete with dishwashers, ceiling fans for comfort, and pet-friendly fenced yards. With easy access to the gardens and all the amenities of Oklahoma City, Summit Ridge Villas is the ideal place to cultivate a fulfilling lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
      "featured_image_media": {
        "alt_text": "Summit Villas logo",
        "public_id": "019cfb54-f460-771f-b11b-25b5156666b5",
        "storage_key": "property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
        "width": 1067,
        "height": 516
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Will Rogers Gardens",
      "seo_description": "Live near Will Rogers Gardens in Northwest OKC at Summit Ridge Villas. Enjoy modern living with nature just a stone's throw away.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167297",
      "source": "generator",
      "page_item_url": "bluff-creek-park-nearby-apartments-oklahoma-county",
      "search_query": "Bluff Creek Park nearby apartments in Oklahoma County",
      "category": "Park",
      "h1_title": "Bluff Creek Park Nearby Apartments",
      "h2_subtitle": "Explore our Bluff Creek Park nearby apartments in Oklahoma County, perfect for nature lovers seeking a convenient urban home at Summit Ridge Villas.",
      "page_copy": "For those eager to embrace both nature and city life, Summit Ridge Villas provides perfect homes near Bluff Creek Park in Oklahoma County. Our community offers a serene retreat with easy access to the lush trails and recreational activities of Bluff Creek Park.\n\nSituated in Northwest Oklahoma City, our pet-friendly apartments feature modern conveniences such as dishwashers, ceiling fans, and fenced yards. Enjoy spending leisure time outdoors while also benefiting from the vibrant lifestyle and amenities available in the city.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
      "featured_image_media": {
        "alt_text": "Summit Villas logo",
        "public_id": "019cfb54-f460-771f-b11b-25b5156666b5",
        "storage_key": "property/6767906449167297/019cfb54-f460-771f-b11b-25b5156666b5.webp",
        "width": 1067,
        "height": 516
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bluff Creek Park Nearby Apartments",
      "seo_description": "Discover Summit Ridge Villas; Bluff Creek Park nearby apartments in OK County. Perfect blend of nature and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5217"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-71NFE0ELHH"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151972"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/summit-villas/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W9RGMHJL"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167297/019d1bd9-e336-767f-b0ee-63014a73a116.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-696-5248"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "69f93403ec06818df8f4f52a"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImZTK0tXeEM4cTJid2oyb0wvVm9VUEE9PSIsInZhbHVlIjoiWTE1K0I0Z3VLMjhPaTdOeDR2TG1uQT09IiwibWFjIjoiNjM1N2UwZTY5NjM2NTVjYjE1MzAwMTQzYjM3NDU4M2JiZWZhZGEyNmZiZTQ0NWU1MTU1ZWY0ODhmMjg4OTMwYyJ9"
    }
  ],
  "custom_qb_id": "5217",
  "custom_ga4_id": "G-71NFE0ELHH",
  "custom_repli_id": "10041151972",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/summit-villas/register/",
  "custom_google_gtm_id": "GTM-W9RGMHJL",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167297/019d1bd9-e336-767f-b0ee-63014a73a116.pdf",
  "custom_ppc_tracking_phone_number": "855-696-5248",
  "custom_residentboost_apartment_id": "69f93403ec06818df8f4f52a",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImZTK0tXeEM4cTJid2oyb0wvVm9VUEE9PSIsInZhbHVlIjoiWTE1K0I0Z3VLMjhPaTdOeDR2TG1uQT09IiwibWFjIjoiNjM1N2UwZTY5NjM2NTVjYjE1MzAwMTQzYjM3NDU4M2JiZWZhZGEyNmZiZTQ0NWU1MTU1ZWY0ODhmMjg4OTMwYyJ9"
};

export const generatedAt = '2026-08-27T21:32:35.317Z';
